<template>
    <div class="pt-3 pl-5 pr-5">
        <div class="mb-2">
            <breadCrumb :routesArray="routesArray"></breadCrumb>
        </div>
        <div class="flex justify-between items-center h-8">
            <div>
                <h1>{{ system.systemName }}</h1>
            </div>
            <div class="flex items-center gap-3">
                <button v-if="selectedIndex == 3 && systemAssesmentList.length != 0" @click="createAssesmentTask()" :class="checkedItems.length > 0 ? 'btnprimary mr-3' : 'btndisabled pointer-events-none mr-3'">Create</button>
                <button class="btnprimary flex items-center" @click="addRiskForSystem" v-if="selectedIndex == 0">Add</button>
                <button class="btnprimary flex items-center" @click="showInformation" v-if="selectedIndex == 1">Add</button>
                <button
                    v-if="selectedIndex != 2"
                    :class="(selectedIndex == 0 && riskList.length != 0) || (selectedIndex == 3 && systemAssesmentList.length != 0) || (selectedIndex == 1 && infoTableRow.length != 0) ? 'filterButton' : 'btndisabled pointer-events-none'"
                    class="flex"
                    @click="filterOpen"
                >
                    <img v-if="(selectedIndex == 0 && riskList.length != 0) || (selectedIndex == 3 && systemAssesmentList.length != 0) || (selectedIndex == 1 && infoTableRow.length != 0)" src="@/assets/filter.svg" class="filterIcon" />
                    <img v-else src="@/assets/filterIcon_Disabled.svg" class="filterIcon"/>
                    Filters
                </button>
            </div>
        </div>
        
        <div class="mainContainer tabStructure w-full bg-white border rounded-sm mt-5 px-5 pt-5 pb-3 border-lightgrey">
            <!-- <div class="group-buttons" v-if="isSmallScreen">
                Group navigation buttons for smaller screens
                <div class="absolute left-0 cursor-pointer" @click="scrollTabs('left')" :class="{ 'disabled pointer-events-none': (selectedIndex === 0 || currentGroupIndex === 0) && isSmallScreen }">
                    <img src="@/assets/leftArrowFilled.svg" class="arrow left-0" />
                </div>
                <div class="absolute right-0 cursor-pointer" @click="scrollTabs('right')" :class="{ 'disabled pointer-events-none': (selectedIndex === carouselHead.length - 1 || currentGroupIndex >= totalGroups - 1) && isSmallScreen }">
                    <img src="@/assets/rightArrowFilled.svg" class="arrow right-0" />
                </div>
            </div>
          
            <div>
                <div>
                    <div class="flex flex-row borderBottom cursor-pointer tab-container" ref="tabContainer" @scroll="handleScroll">
                        <div class="pb-1" :class="selectedIndex == tab.id ? 'adjust header font-semibold text-primary':'text-sm text-disabledgrey'" v-for="(tab, index) in visibleTabs" :key="index" @click="toggleTabs(tab)">
                            <div>
                                <div ref="actualIndex" class="cursor-pointer">{{ tab.displayName }}</div>
                                <div :class="{ progress: selectedIndex === tab.id }" class="h-1 p-0.75 relative rounded"></div>
                            </div>
                        </div>
                    </div>
                </div>
 
                <div class="progressbarB rounded h-1"></div>
            </div> -->
            <Tabs v-model:value="selectedIndex" scrollable class="heightFixing pr-5">
                  <div>
                    <TabList >
                        <Tab v-for="(tab) in visibleTabs" :key="tab.id" :value="tab.id" @click="toggleTabs(tab)">
                            {{ tab.displayName }}
                        </Tab>
                    </TabList>
                  </div>
            <TabPanels class="overflow-auto hide-scrollbar">
            <TabPanel v-for="(tab) in visibleTabs" :key="tab.id" :value="tab.id">
            <div v-if="dataLoading == true">
                <div class="flex items-center justify-center w-full h-16 skeleton">
                <dots-loader/>
                </div>
            </div>
            <div v-else class="w-full">
                <div v-if="selectedIndex == 0" class="noScrollbar tabControlMapping">
                    <newTable :tableRowData="riskList" :headersData="riskHeaders" :openPopup="true" :loadData="dataLoading"></newTable>
                    <div v-if="toolTipActive">
                        <tool-tip :tipText="toolTipText"></tool-tip>
                    </div>
                </div>
                <div class="businesssPopup noScrollbar tabControlMapping" v-if="selectedIndex == 1">
                    <newTable :tableRowData="infoTableRow" :headersData="informationHeaders" :openPopup="true" :loadData="dataLoading"></newTable>
                    <div v-if="toolTipActive">
                        <tool-tip :tipText="toolTipText"></tool-tip>
                    </div>
                </div>
                <div v-if="selectedIndex == 2" class="noScrollbar tabControlMapping">
                    <fieldset :disabled="true">
                        <!-- <div class="card"> -->
                        <div class="statuscontainer">
                            <div class="formcontainer flex flex-col">
                                <div class="row flex flex-row w-full upperspacing">
                                    <div class="w-6/12">
                                        <label class="controllabel">Name</label>
                                        <div class="text-sm">{{system.systemName}}</div>
                                        
                                    </div>
                                    <div class="w-6/12 leftspacing">
                                        <label class="controllabel">Status</label>
                                        <div v-if="system.isActive && system.isActive==true" class="flex items-center justify-center rounded h-5 w-24 mt-2" :class="colorStatusBg(1)">
                                            <div class="text-xs" :class="colorStatusText(1)">
                                                {{ getStatusLabel(1) }}
                                            </div>
                                        </div>
                                        <div v-else-if="(system.isActive!=undefined && system.isActive==false)|| !system.isActive"	class="flex items-center justify-center rounded h-5 w-24 mt-2" :class="colorStatusBg(2)">
                                            <div class="text-xs" :class="colorStatusText(2)">
                                            {{ getStatusLabel(2) }}
                                            </div>
                                        </div>
                                        <div v-else class="text-sm mt-2">N/A</div>
                                    </div>
                                </div>
                                <div class="row flex flex-row w-full upperspacing">
                                    <div class="w-6/12">
                                        <label class="controllabel">Category</label>
                                        <div class="text-sm">
                                            {{system.systemCategory||'N/A'}}
                                            
                                        </div>
                                        
                                    </div>
                                    <div class="w-6/12 leftspacing">
                                        <label class="controllabel">Owner</label>
                                        <div class="text-sm">
                                            {{system.owner && Object.keys(system.owner).includes('label') ? `${system.owner.label}`:'N/A'}}
                                            
                                        </div>
                                        
                                    </div>
                                </div>
                                <div class="row flex flex-row w-full upperspacing">
                                    <div class="w-3/6">
                                        <label class="controllabel">Internet Facing</label>
                                        <div class="text-sm">  {{ yesNo.find(option => option.id === system.publicFacing)?.value || "N/A" }}</div>
                                        
                                    </div>
                                    
                                    <div class="w-3/6 leftspacing">
                                        <label class="controllabel">URL/IP</label>
                                        <div class="text-sm">{{system.add||'N/A'}}</div>
                                        
                                    </div>
                                </div>
                                <div class="row flex flex-row w-full upperspacing">
                                    <div class="w-full">
                                        <label class="controllabel">Description</label>
                                        <div class="text-sm">{{system.description||'N/A'}}</div>
                                    </div>
                                </div>
                                <h1 class="mt-4">Hosting Information</h1>
							    <div class="border-b mt-1 border-solid border-lightgrey"></div>
                                
                                    
                                    <!-- <div class="w-full upperspacing">
                                        <label class="controllabel">Model</label>
                                        <div class="text-sm">
                                            {{ system.hostingType }}
                                        </div>
                                        
                                    </div>
                                    <div class="w-full upperspacing leftspacing">
                                        <label class="controllabel">State</label>
                                        <div class="text-sm">{{system.hostingProvider}}</div>
                                        
                                    </div>
                                    <div class="w-full upperspacing">
                                        <label class="controllabel">Country</label>
                                        <div class="text-sm">{{system.country}}</div>
                                        
                                    </div>
                                    <div class="w-full upperspacing leftspacing">
                                        <label class="controllabel">City</label>
                                        <div class="text-sm">{{system.city}}</div>
                                        
                                    </div> -->
                                    <div class="row flex flex-row w-full upperspacing">
                                        <div class="w-3/6">
                                            <label class="text-xs font-extrabold">Model</label>
                                            <div class="mb-3 mt-2 text-sm">{{ system?.hostingType || 'N/A' }}</div>
                                        </div>
                                        <div class="w-3/6 pl-4" v-if="system.hostingType=='On-premise'">
                                            <label class="text-xs font-extrabold">Location</label>
                                            <div class="mb-3 mt-2 text-sm">{{system.ownedBy?.label || 'N/A' }}</div>
                                        </div>
                                        <div class="w-3/6 leftspacing" v-if="system.hostingType=='Data Center'|| system.hostingType=='Cloud'">
                                            <label class="text-xs font-extrabold">Country</label>
                                            <div class="mb-3 mt-2 text-sm">{{ system?.country || 'N/A' }}</div>
                                        </div>
                                        
                                    </div>
                                    <div class="row flex flex-row w-full" v-if="system?.hostingType =='Data Center'||system?.hostingType =='Cloud'">
                                        <div class="w-3/6">
                                            <label class="text-xs font-extrabold">State</label>
                                            <div class="mb-3 mt-2 text-sm">{{ system?.state || 'N/A' }}</div>
                                        </div>
                                        <div class="w-3/6 leftspacing">
                                            <label class="text-xs font-extrabold">City</label>
                                            <div class="mb-3 mt-2 text-sm">{{ system?.city || 'N/A' }}</div>
                                        </div>
                                    </div>
                                    <div class="row flex flex-col w-full" v-if="system?.hostingType =='Data Center'||system?.hostingType =='Cloud'">
                                        <div class="">
                                            <label class="text-xs font-extrabold">Vendor</label>
                                            <div class="mb-3 mt-2 text-sm">{{ managedByOptions.find(a=>a.value==system?.hostingProvider)?.label || 'N/A' }}</div>		
                                        </div>
                                    </div>
                                    
                                
                            </div>
                        </div>
                    </fieldset>
                </div>

                <div v-if="selectedIndex == 3" class="noScrollbar tabControlMapping">
                    <!-- <div v-if="discovery == true">
                        <div class="flex-col justify-center items-center">
                            <div class="loader mr-2"></div>
                        </div>
                        <p class="text-center font-semibold">Discovering Risks</p>
                    </div> -->
                    <div class="tableCornerRadius" v-if="discovery == false">
                        <div class="table-container">
                        <table>
                            <thead>
                                <th class="header cursor-pointer" style="width: 5%;">
                                    <div class="flex items-center w-4">
                                        <input type="checkbox" class="checkbox cursor-pointer" v-model="selectAll" :disabled="sortedData.length == 0" @change="selectAllOptions($event)" />
                                    </div>
                                </th>
                                <th class="header cursor-pointer" style="width: 15%;" @click="sort('severity')">
                                    <div class="flex items-center w-28">
                                        <div>Severity</div>

                                        <div class="sort cursor-pointer" :class="className == 'severity' ? classSort : 'opacity-50'"></div>
                                    </div>
                                </th>
                                <th class="header cursor-pointer" style="width: 25%;" @click="sort('risk')">
                                    <div class="flex items-center w-44">
                                        <div>Risk</div>

                                        <div class="sort cursor-pointer" :class="className == 'risk' ? classSort : 'opacity-50'"></div>
                                    </div>
                                </th>
                                <th class="header cursor-pointer" style="width: 25%;" @click="sort('riskCategory')">
                                    <div class="flex items-center w-32">
                                        <div>Category</div>

                                        <div class="sort cursor-pointer" :class="className == 'riskCategory' ? classSort : 'opacity-50'"></div>
                                    </div>
                                </th>
                                <!-- <th class="header cursor-pointer" @click="sort('overallImpact')">
                                        <div class="flex items-center ml-4">
                                            <div>Impact</div>

                                            <div class="sort cursor-pointer" :class="className == 'overallImpact' ? classSort : 'opacity-50'"></div>
                                        </div>
                                    </th> -->
                                <th class="header cursor-pointer" style="width: 15%;" @click="sort('likelihood')">
                                    <div class="flex items-center ml-3 w-28">
                                        <div>Likelihood</div>

                                        <div class="sort cursor-pointer" :class="className == 'likelihood' ? classSort : 'opacity-50'"></div>
                                    </div>
                                </th>
                                <th class="header cursor-pointer" style="width: 15%;" @click="sort('overallImpact')">
                                    <div class="flex items-center mr-3 w-28">
                                        <div>Overall Impact</div>
                                        <div class="sort cursor-pointer" :class="className == 'overallImpact' ? classSort : 'opacity-50'"></div>
                                    </div>
                                </th>

                                <tr v-if="showFilters">
                                    <td></td>
                                    <td class="w-36">
                                        <select class="widthForSelect" :class="filterDummy.severity == '' ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'" v-model="filterDummy.severity">
                                            <option value="" selected disabled hidden>Select</option>
                                            <option class="optionColors" v-for="pair in dbSeverity" :key="pair" :value="pair.value">{{ pair.key }}</option>
                                        </select>
                                    </td>
                                    <td class="searchRow">
                                        <input type="text" class="inputboxStylingForFilter filter-font-size" placeholder="Search" v-model="filterDummy.risk" />
                                    </td>
                                    <td class="searchRow">
                                        <input type="text" class="searchForInputBoxStyling filter-font-size" placeholder="Search" v-model="filterDummy.riskCategory" />
                                    </td>
                                    <!-- <td>
                                            <select class="inputboxstyling resize" v-model="filterDummy.overallImpact">
                                                <option value="" selected disabled hidden>Select</option>
                                                <option v-for="pair in risksSeverityValue" :key="pair" :value="pair.id">{{ pair.value }}</option>
                                            </select>
                                        </td> -->
                                    <td class="searchRow">
                                        <select class="widthForSelect" :class="filterDummy.likelihood == '' ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'" v-model="filterDummy.likelihood">
                                            <option value="" selected disabled hidden>Select</option>
                                            <option class="optionColors" v-for="pair in dbLikelihood" :key="pair" :value="pair.value">{{ pair.key }}</option>
                                        </select>
                                    </td>
                                    <td class="searchRow">
                                        <select class="widthForSelect" :class="filterDummy.overallImpact == '' ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'" v-model="filterDummy.overallImpact">
                                            <option value="" selected disabled hidden>Select</option>
                                            <option class="optionColors" v-for="pair in dbOverAllImpact" :key="pair" :value="pair.value">{{ pair.key }}</option>
                                        </select>
                                    </td>
                                </tr>
                            </thead>
                            <tbody v-if="sortedData.length == 0">
                                <tr class="cursor-pointer rowHeight">
                                    <td :colspan="6">
                                        <div class="flex justify-center"><p class="text-xs font-normal">No Records Found</p></div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody class="nonEmptyTable" v-else>
                                <tr v-for="(riskItem, index) in sortedData" class="rowHeight" :key="index" @click="openRisk(riskItem)">
                                    <td @mouseout="doFalse()">
                                        <input class="checkbox" type="checkbox" v-model="checkedItems" :value="riskItem._id" @change="changeInfo(riskItem, $event)" />
                                    </td>
                                    <td class="relative cursor-pointer" @mouseout="doFalse()">
                                        <!-- <div class="relative w-36 regular pl-2"> -->
                                            <div class="flex items-center justify-center rounded-full ml-2 w-5 h-5" @mousemove="toolTip(riskItem, 'severity', riskItem.severity, index, $event)" :class="colorPropBg('border', riskItem.severity)">
                                                <div class="severityCircle rounded-full" :class="colorPropBg('circle', riskItem.severity)"></div>
                                            </div>
                                        <!-- </div> -->
                                    </td>

                                    <td class="relative" @mouseout="doFalse()">
                                        <div class="table-ellipsis">
                                            <p class="cursor-pointer text-xs" @mousemove="toolTip(riskItem, 'risk', riskItem.risk, index, $event)">{{ riskItem.risk }}</p>
                                        </div>
                                    </td>
                                    <td class="relative" @mouseout="doFalse()">
                                        <div class="table-ellipsis">
                                            <p class="cursor-pointer text-xs" @mousemove="toolTip(riskItem, 'riskCategory', riskItem.riskCategory, index, $event)">{{ riskItem.riskCategory }}</p>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="flex items-center justify-center relative rounded regular text-xs w-24 h-5" :class="colorRiskText(riskItem.likelihood)">
                                            <div class="w-full h-full absolute rounded flex items-center justify-center " v-if="!isNaN(riskItem.likelihood)" :class="colorRiskBg(riskItem.likelihood)">
                                                {{ getRiskStateValue(riskItem.likelihood) }}
                                            </div>
                                        </div>
                                        <!-- <div class="flex items-center relative rounded regular text-xs w-24 h-5" :class="colorRiskText(riskItem.likelihood)">
                                            <div class="w-full h-full absolute rounded" :class="colorRiskBg(riskItem.likelihood)"></div>
                                            <div class="flex rounded w-24 items-center regular text-xs tip">
                                                <div v-if="!isNaN(riskItem.likelihood)">
                                                    <div class="flex w-24 items-center justify-center regular pb-px">
                                                        {{ getRiskStateValue(riskItem.likelihood) }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div> -->
                                    </td>
                                    <td>
                                        <div class="flex items-center justify-center relative rounded regular text-xs w-24 h-5" :class="colorRiskText(riskItem.overallImpact)">
                                            <div class="w-full h-full absolute rounded flex items-center justify-center " v-if="!isNaN(riskItem.overallImpact)" :class="colorRiskBg(riskItem.overallImpact)">
                                                {{ getOverallValue(riskItem.overallImpact) }}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        </div>
                        <div v-if="sortedData.length > 0">
                            <pagination :dynamicPagination="dynamicPagination" @currentPageUpdate="paginationUpdations" :sortedData="sortedData"></pagination>
                        </div>
                    </div>
                    <div v-if="toolTipActive">
                        <tool-tip :tipText="toolTipText"></tool-tip>
                    </div>
                </div>
            </div>
            </TabPanel>
            </TabPanels>
            </Tabs>
        </div>
        
        <popup v-if="openRiskPopup" :popUp="openRiskPopup">
            <template v-slot:header>
                <div class="flex items-center justify-between popupheadingcontainer rounded">
                    <h1>Risk Information</h1>
                    <button class="float-right text-3xl" @click="onCrossbtn()">
                        <img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
                    </button>
                </div>
            </template>
            <div class='flex flex-col h-full'>
                <div class="flex-1 overflow-auto">
                    <div class="popup-business">
                        <div>
                            <div class="statuscontainer popupbodycontainer">
                                <div class="formcontainer flex flex-col">
                                    <div class="row flex flex-row w-full">
                                        <div class="upperspacing w-full">
                                            <label for="Risk" class="controllabel">Risk</label>
                                            <div v-if="riskThreatData.statusCode==10401 || addingRisk==true">
                                            <textarea
                                                class="inputboxstyling"
                                                placeholder="Risk"
                                                v-model.trim="riskThreatData.risk"
                                                @input ="restrictCharacters('Risk')"
                                                :class="{
                                                    'is-invalid': v$.riskThreatData.risk.$error||displayErrorMessageOfRisk
                                                }"
                                            />
                                            <div v-if="v$.riskThreatData.risk.$error" class="text-red-500">
                                                <div class="error-text text-xs" v-if="v$.riskThreatData.risk.required.$invalid">Required</div>
                                            </div>
                                            <div v-else-if="displayErrorMessageOfRisk == true">
                                                <div class="text-red-500 text-xs">Character Limit is exceeded</div>
                                            </div>
                                            </div>
                                            <div v-else class="text-sm">
                                                {{riskThreatData.risk||'N/A'}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row flex flex-row w-full upperspacing">
                                        <div class="w-6/12">
                                            <div>
                                                <label class="controllabel">Risk Category</label>
                                                <!-- <Multiselect
                                                    v-model="riskThreatData.riskCategory"
                                                    :options="riskCategoryList"
                                                    :multiple="false"
                                                    :searchable="true"
                                                    :hide-selected="true"
                                                    open-direction="bottom"
                                                    :close-on-select="true"
                                                    :show-labels="false"
                                                    class="custom-multiselect"
                                                    placeholder="Risk Category"
                                                    :class="{
                                                        'is-invalidmultiselect': v$.riskThreatData.riskCategory.$error,
                                                        'has-options': riskCategoryList && riskCategoryList.length > 0,
                                                    'no-options':  !riskCategoryList.length,
                                                    }"
                                                >
                                                    <template v-slot:noResult>
															<span class="text-xs">No Categories Found</span>
														</template>
                                                </Multiselect> -->
                                                <div v-if="riskThreatData.statusCode==10401 || addingRisk==true">
                                                <!-- <Select
                                                        v-model="riskThreatData.riskCategory"
                                                        :options="riskCategoryList"
                                                        placeholder="Risk Category"
                                                        class="custom-multiselect w-full"
                                                        :class="{
                                                                'is-invalid': v$.riskThreatData.riskCategory.$error,
                                                                'has-options': riskCategoryList && riskCategoryList.length > 0,
                                                                'no-options':  !riskCategoryList.length,
                                                            }"
                                                    >
                                                    <template v-slot:noResult>
                                                        <span class="text-xs">No Categories Found</span>
                                                    </template>
                                                </Select> -->
                                                <AutoComplete
                                                        v-model="riskThreatData.riskCategory"
                                                        :suggestions="searchRiskCategoryList"
                                                        @complete="asyncRiskCategoryDataFind"
                                                        @item-select="selectedRiskCategoryOption"
                                                        placeholder="Risk Category"
                                                        field="label"
                                                        class="w-full"
                                                        :class="{
                                                            'p-invalid': v$.riskThreatData.riskCategory.$error,
                                                            'has-options': searchRiskCategoryList && searchRiskCategoryList.length > 0,
                                                            'no-options': !searchRiskCategoryList.length && searchValue !== '',
                                                        }"
                                                    >
                                                    <template #empty>
                                                        <span class="text-xs">No Categories Found</span>
                                                    </template>
                                                </AutoComplete>
                                                <div v-if="v$.riskThreatData.riskCategory.$error" class="text-red-500">
                                                    <div class="error-text text-xs" v-if="v$.riskThreatData.riskCategory.required.$invalid">Required</div>
                                                </div>
                                                </div>
                                                <div v-else class="text-sm">
                                                    {{riskThreatData.riskCategory||'N/A'}}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="w-3/6 leftspacing">
                                            <label class="controllabel">Risk Owner</label>
                                            <!-- <multiselect
                                                v-model="riskThreatData.riskOwner"
                                                :options="userOptions"
                                                :showNoOptions="false"
                                                @search-change="asyncFind"
                                                :limit-text="limitText"
                                                :multiple="false"
                                                :hide-selected="true"
                                                :close-on-select="true"
                                                :clear-on-select="true"
                                                open-direction="bottom"
                                                label="label"
                                                track-by="value"    
                                                :searchable="true"
                                                :hideArrow="false"
                                                placeholder="Risk Owner"
                                                class="custom-multiselect userSelect"
                                                :class="{
                                                    'is-invalidmultiselect': v$.riskThreatData.riskOwner.$error,
                                                    'has-options': userOptions && userOptions.length > 0,
                                                    'no-options': !userOptions.length && searchValue !== '',
                                                }"
                                            >
                                                <template v-slot:noResult>
                                                    <span class="text-xs">No Members Found</span>
                                                </template>
                                            </multiselect> -->
                                            <div v-if="riskThreatData.statusCode==10401|| addingRisk==true">
                                            <AutoComplete
                                                    v-model="riskThreatData.riskOwner"
                                                    :suggestions="userOptions"
                                                    @complete="asyncFind"
                                                    optionLabel="label"
                                                    optionValue="value"
                                                    forceSelection
                                                    placeholder="Risk Owner"
                                                    class="custom-multiselect w-full"
                                                    :class="{
                                                        'p-invalid': v$.riskThreatData.riskOwner.$error,
                                                        'has-options': userOptions && userOptions.length > 0,
                                                        'no-options': !userOptions.length &&  searchValue !== '',
                                                    }"
                                                >
                                                    <template #empty>
                                                        <span class="text-xs">No Members Found</span>
                                                    </template>
                                                </AutoComplete>
                                            <div v-if="v$.riskThreatData.riskOwner.$error" class="text-red-500">
                                                <div class="error-text text-xs" v-if="v$.riskThreatData.riskOwner.required.$invalid">Required</div>
                                            </div>
                                            </div>
                                            <div v-else class="text-sm">
                                                {{riskThreatData.riskOwner?.label||'N/A'}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row flex flex-row w-full upperspacing">
                                        <div class="w-full">
                                            <label for="Risk" class="controllabel">Threat</label>
                                            <div v-if="riskThreatData.statusCode==10401|| addingRisk==true">
                                            <textarea
                                                class="inputboxstyling"
                                                placeholder="Threat"
                                                @input ="restrictCharacters('Threat')"
                                                v-model.trim="riskThreatData.threatEvent"
                                                :class="{
                                                    'is-invalid': v$.riskThreatData.threatEvent.$error||displayErrorMessageOfThreat
                                                }"
                                            />

                                            <div v-if="v$.riskThreatData.threatEvent.$error" class="text-red-500">
                                                <div class="error-text text-xs" v-if="v$.riskThreatData.threatEvent.required.$invalid">Required</div>
                                            </div>
                                            <div v-else-if="displayErrorMessageOfThreat == true">
                                                <div class="text-red-500 text-xs">Character Limit is exceeded</div>
                                            </div>
                                            </div>
                                            <div v-else class="text-sm">
                                                {{riskThreatData.threatEvent||'N/A'}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row flex flex-row w-full upperspacing">
                                        <div class="w-6/12">
                                            <label class="controllabel">Threat Source</label>
                                            <!-- <Multiselect
                                                v-model="riskThreatData.threatSource"
                                                :options="threatSourceList"
                                                :multiple="false"
                                                :searchable="true"
                                                :hide-selected="true"
                                                open-direction="bottom"
                                                :close-on-select="true"
                                                :show-labels="false"
                                                class="custom-multiselect"
                                                placeholder="Threat Source"
                                                :class="{
                                                    'has-options': threatSourceList && threatSourceList.length > 0,
                                                    'no-options':  !threatSourceList.length,
                                                }"
                                            >
                                                <template v-slot:noResult>
                                                    <span class="text-xs">No Source Found</span>
                                                </template>
                                            </Multiselect> -->
                                            <div v-if="riskThreatData.statusCode==10401|| addingRisk==true">
                                            <!-- <Select
                                                v-model="riskThreatData.threatSource"
                                                :options="threatSourceList"
                                                placeholder="Threat Source"
                                                class="custom-multiselect w-full"
                                                :class="{
                                                    'has-options': threatSourceList && threatSourceList.length > 0,
                                                    'no-options':  !threatSourceList.length,

                                                }"
                                            >
                                            <template v-slot:noResult>
                                                <span class="text-xs">No Source Found</span>
                                            </template>
                                            </Select> -->
                                            <AutoComplete
                                                        v-model="riskThreatData.threatSource"
                                                        :suggestions="searchThreatSourceList"
                                                        @complete="asyncthreatSourceDataFind"
                                                        @item-select="selectedThreatSourceOption"
                                                        placeholder="Threat Source"
                                                        field="label"
                                                        class="w-full"
                                                        :class="{
                                                            'has-options': searchThreatSourceList && searchThreatSourceList.length > 0,
                                                            'no-options': !searchThreatSourceList.length && searchValue !== '',
                                                        }"
                                                    >
                                                        <template #empty>
                                                            <span class="text-xs">No Source Found</span>
                                                        </template>
                                            </AutoComplete>
                                        </div>
                                            <div v-else class="text-sm">
                                                {{riskThreatData.threatSource||'N/A'}}
                                            </div>
                                        </div>
                                        <div class="w-6/12 leftspacing">
                                            <label class="controllabel">Threat Category</label>
                                            <!-- <Multiselect
                                                v-model="riskThreatData.threatCategory"
                                                :options="threatCategoryList"
                                                :multiple="false"
                                                :searchable="true"
                                                :hide-selected="true"
                                                open-direction="bottom"
                                                :close-on-select="true"
                                                :show-labels="false"
                                                class="custom-multiselect"
                                                placeholder="Threat Category"
                                                :class="{
                                                    'has-options': threatCategoryList && threatCategoryList.length > 0,
                                                    'no-options':  !threatCategoryList.length,
                                                }"
                                            >
                                                <template v-slot:noResult>
                                                    <span class="text-xs">No Categories Found</span>
                                                </template>
                                            </Multiselect> -->
                                            <div v-if="riskThreatData.statusCode==10401|| addingRisk==true">
                                            <!-- <Select
                                                    v-model="riskThreatData.threatCategory"
                                                    :options="threatCategoryList"
                                                    placeholder="Threat Category"
                                                    class="custom-multiselect w-full"
                                                    :class="{
                                                        'has-options': threatCategoryList && threatCategoryList.length > 0,
                                                        'no-options':  !threatCategoryList.length,

                                                    }"
                                                >
                                                <template v-slot:noResult>
                                                    <span class="text-xs">No Categories Found</span>
                                                </template>
                                                 </Select> -->
                                                 <AutoComplete
                                                    v-model="riskThreatData.threatCategory"
                                                    :suggestions="searchThreatCategoryList"
                                                    @complete="asyncthreatCategoryDataFind"
                                                    @item-select="selectedOption"
                                                    placeholder="Threat Category"
                                                    field="label"
                                                    class="w-full"
                                                    :class="{
                                                        'has-options': searchThreatCategoryList && searchThreatCategoryList.length > 0,
                                                        'no-options': !searchThreatCategoryList.length && searchValue !== '',
                                                    }"
                                                >
                                                    <template #empty>
                                                        <span class="text-xs">No Categories Found</span>
                                                    </template>
                                            </AutoComplete>
                                            </div>
                                            <div v-else class="text-sm">
                                                {{riskThreatData.threatCategory||'N/A'}}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row flex flex-row w-full upperspacing">
                                        <div class="w-full">
                                            <label for="Risk" class="controllabel">Vulnerability</label>
                                            <div v-if="riskThreatData.statusCode==10401|| addingRisk==true">
                                            <textarea
                                                class="inputboxstyling"
                                                placeholder="Vulnerability"
                                                @input ="restrictCharacters('Vulnerability')"
                                                v-model.trim="riskThreatData.vulnerability"
                                                :class="{
                                                    'is-invalid': v$.riskThreatData.vulnerability.$error||displayErrorMessageOfVulnerability
                                                }"
                                            />

                                            <div v-if="v$.riskThreatData.vulnerability.$error" class="text-red-500">
                                                <div class="error-text text-xs" v-if="v$.riskThreatData.vulnerability.required.$invalid">Required</div>
                                            </div>
                                            <div v-else-if="displayErrorMessageOfVulnerability == true">
                                                <div class="text-red-500 text-xs">Character Limit is exceeded</div>
                                            </div>
                                            </div>
                                            <div v-else class="text-sm">
                                                {{riskThreatData.vulnerability||'N/A'}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row flex flex-row w-full upperspacing">
                                        <div class="w-full">
                                            <label for="Risk" class="controllabel">Risk Assessment</label>
                                            <div v-if="riskThreatData.statusCode==10401|| addingRisk==true">
                                            <textarea
                                                class="inputboxstyling"
                                                placeholder="Risk Assessment"
                                                @input ="restrictCharacters('Assessment')"
                                                v-model.trim="riskThreatData.riskAssessment"
                                                :class="{
                                                    'is-invalid': v$.riskThreatData.riskAssessment.$error||displayErrorMessageOfAssessment
                                                }"
                                            />

                                            <div v-if="v$.riskThreatData.riskAssessment.$error" class="text-red-500">
                                                <div class="error-text text-xs" v-if="v$.riskThreatData.riskAssessment.required.$invalid">Required</div>
                                            </div>
                                            <div v-else-if="displayErrorMessageOfAssessment == true">
                                                <div class="text-red-500 text-xs">Character Limit is exceeded</div>
                                            </div>
                                            </div>
                                            <div v-else class="text-sm">
                                                {{riskThreatData.riskAssessment||'N/A'}}
                                            </div>
                                        </div>
                                    </div>

                                    <h1 class="upperspacing">Revised Impact</h1>
                                    <div class="border-b pt-1 border-solid border-lightgrey"></div>
                                    <div class="row flex flex-row w-full upperspacing">
                                        <div class="w-6/12">
                                            <label class="controllabel">Strategic</label>
                                            <!-- <select
                                                class="inputboxstylingForSelect"
                                                v-model="riskThreatData.business"
                                                :class="{
                                                    'is-invalid': v$.riskThreatData.business.$error,'inputboxstylingForSelectAtPopup': riskThreatData.business === '','stylingForInputboxstylingForSelectAtPopup': riskThreatData.business !== ''
                                                }"
                                                @change="calculateOverallImpact()"
                                            >
                                                <option value="" selected hidden>Please select one</option>
                                                <option class="optionColors" v-for="i in dbBussiness" :value="i.value" :key="i">
                                                    {{ i.key }}
                                                </option>
                                            </select> -->
                                            <div v-if="riskThreatData.statusCode==10401|| addingRisk==true">
                                            <Select
                                                v-model="riskThreatData.business"
                                                :options="dbBussiness"
                                                optionLabel="key"
                                                optionValue="value"
                                                placeholder="Please select one"
                                                @change="calculateOverallImpact()"
                                                class="custom-multiselect w-full"
                                                :class="{
                                                    'is-invalid': v$.riskThreatData.business.$error,
                                                    'inputboxstylingForSelectAtPopup': riskThreatData.business === '',
                                                    'stylingForInputboxstylingForSelectAtPopup': riskThreatData.business !== ''
                                                }"
                                            />
                                            <div v-if="v$.riskThreatData.business.$error" class="text-red-500">
                                                <div class="error-text text-xs" v-if="v$.riskThreatData.business.required.$invalid">Required</div>
                                            </div>
                                            </div>
                                            <div v-else-if="riskThreatData.residual && riskThreatData.residual.length > 0  && riskThreatData.action!=10419  && riskThreatData.statusCode!=10401" class="text-sm">
                                                {{ lablesData(riskThreatData.residual[riskThreatData.residual.length - 1]?.business,1) || 'N/A'}}
                                            </div>
                                            <div v-else class="text-sm">
                                                {{lablesData(riskThreatData.business,1)||'N/A'}}
                                            </div>
                                        </div>
                                        <div class="w-6/12 leftspacing">
                                            <label class="controllabel">Financial</label> 

                                            <!-- <select
                                                class="inputboxstylingForSelect"
                                                v-model="riskThreatData.financial"
                                                :class="{
                                                    'is-invalid': v$.riskThreatData.financial.$error,'inputboxstylingForSelectAtPopup': riskThreatData.financial === '','stylingForInputboxstylingForSelectAtPopup': riskThreatData.financial !== ''
                                                }"
                                                @change="calculateOverallImpact()"
                                            >
                                                <option value="" selected hidden>Please select one</option>
                                                <option class="optionColors" v-for="i in dbFinancial" :value="i.value" :key="i">
                                                    {{ i.key }}
                                                </option>
                                            </select> -->
                                            <div v-if="riskThreatData.statusCode==10401|| addingRisk==true">
                                            <Select
                                                v-model="riskThreatData.financial"
                                                :options="dbFinancial"
                                                optionLabel="key"
                                                optionValue="value"
                                                placeholder="Please select one"
                                                @change="calculateOverallImpact()"
                                                class="custom-multiselect w-full"
                                                :class="{
                                                    'is-invalid': v$.riskThreatData.business.$error,
                                                    'inputboxstylingForSelectAtPopup': riskThreatData.business === '',
                                                    'stylingForInputboxstylingForSelectAtPopup': riskThreatData.business !== ''
                                                }"
                                            />
                                            <div v-if="v$.riskThreatData.financial.$error" class="text-red-500">
                                                <div class="error-text text-xs" v-if="v$.riskThreatData.financial.required.$invalid">Required</div>
                                            </div>
                                            </div>
                                            <div v-else-if="riskThreatData.residual && riskThreatData.residual.length > 0 && riskThreatData.action!=10419 && riskThreatData.statusCode!=10401" class="text-sm">
                                                {{ lablesData(riskThreatData.residual[riskThreatData.residual.length - 1]?.financial,2) || 'N/A'}}
                                            </div>
                                            <div v-else class="text-sm">
                                                {{lablesData(riskThreatData.financial,2)||'N/A'}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row flex flex-row w-full upperspacing">
                                        <div class="w-6/12">
                                            <label class="controllabel">Operations</label>
                                            <!-- <select
                                                class="inputboxstylingForSelect"
                                                v-model="riskThreatData.operations"
                                                :class="{
                                                    'is-invalid': v$.riskThreatData.operations.$error,'inputboxstylingForSelectAtPopup': riskThreatData.operations === '','stylingForInputboxstylingForSelectAtPopup': riskThreatData.operations !== ''
                                                }"
                                                @change="calculateOverallImpact()"
                                            >
                                                <option value="" selected hidden>Please select one</option>
                                                <option class="optionColors" v-for="i in dbOperations" :value="i.value" :key="i">
                                                    {{ i.key }}
                                                </option>
                                            </select> -->
                                            <div v-if="riskThreatData.statusCode==10401|| addingRisk==true">
                                            <Select
                                                v-model="riskThreatData.operations"
                                                :options="dbOperations"
                                                optionLabel="key"
                                                optionValue="value"
                                                placeholder="Please select one"
                                                @change="calculateOverallImpact()"
                                                class="custom-multiselect w-full"
                                                :class="{
                                                   'is-invalid': v$.riskThreatData.operations.$error,
                                                   'inputboxstylingForSelectAtPopup': riskThreatData.operations === '',
                                                   'stylingForInputboxstylingForSelectAtPopup': riskThreatData.operations !== ''
                                                }"
                                            />
                                            <div v-if="v$.riskThreatData.operations.$error" class="text-red-500">
                                                <div class="error-text text-xs" v-if="v$.riskThreatData.operations.required.$invalid">Required</div>
                                            </div>
                                            </div>
                                            <div v-else-if="riskThreatData.residual && riskThreatData.residual.length > 0 && riskThreatData.action!=10419 && riskThreatData.statusCode!=10401" class="text-sm">
                                                {{ lablesData(riskThreatData.residual[riskThreatData.residual.length - 1]?.operations,3) || 'N/A'}}
                                            </div>
                                            <div v-else class="text-sm">
                                                {{lablesData(riskThreatData.operations,3)||'N/A'}}
                                            </div>
                                        </div>
                                        <div class="w-6/12 leftspacing">
                                            <label class="controllabel">Compliance</label>
                                            <!-- <select
                                                class="inputboxstylingForSelect"
                                                v-model="riskThreatData.legal"
                                                :class="{
                                                    'is-invalid': v$.riskThreatData.legal.$error,'inputboxstylingForSelectAtPopup': riskThreatData.legal === '','stylingForInputboxstylingForSelectAtPopup': riskThreatData.legal !== ''
                                                }"
                                                @change="calculateOverallImpact()"
                                            >
                                                <option value="" selected hidden>Please select one</option>
                                                <option class="optionColors" v-for="i in dbLegal" :value="i.value" :key="i">
                                                    {{ i.key }}
                                                </option>
                                            </select> -->
                                            <div v-if="riskThreatData.statusCode==10401|| addingRisk==true">
                                            <Select
                                                v-model="riskThreatData.legal"
                                                :options="dbLegal"
                                                optionLabel="key"
                                                optionValue="value"
                                                placeholder="Please select one"
                                                @change="calculateOverallImpact()"
                                                class="custom-multiselect w-full"
                                                :class="{
                                                   'is-invalid': v$.riskThreatData.legal.$error,
                                                   'inputboxstylingForSelectAtPopup': riskThreatData.legal === '',
                                                   'stylingForInputboxstylingForSelectAtPopup': riskThreatData.legal !== ''
                                                }"
                                            />
                                            <div v-if="v$.riskThreatData.legal.$error" class="text-red-500">
                                                <div class="error-text text-xs" v-if="v$.riskThreatData.legal.required.$invalid">Required</div>
                                            </div>
                                            </div>
                                            <div v-else-if="riskThreatData.residual && riskThreatData.residual.length > 0 && riskThreatData.action!=10419 && riskThreatData.statusCode!=10401" class="text-sm">
                                                {{ lablesData(riskThreatData.residual[riskThreatData.residual.length - 1]?.legal,4) || 'N/A'}}
                                            </div>
                                            <div v-else class="text-sm">
                                                {{lablesData(riskThreatData.legal,4)||'N/A'}}
                                            </div>
                                        </div>
                                    </div>

                                     <div class="w-6/12 upperspacing">
                                        <label class="controllabel">Overall Impact</label>
                                        <!-- <select class="inputboxstyling" disabled v-model="riskThreatData.overallImpact">
                                            <option value="" selected hidden>Please select one</option>
                                            <option v-for="i in dbOverAllImpact" :value="i.value" :key="i">
                                                {{ i.key }}
                                            </option>
                                        </select> -->
                                        <div v-if="riskThreatData.statusCode==10401|| addingRisk==true">
                                        <Select
                                            v-model="riskThreatData.overallImpact"
                                            :options="dbOverAllImpact"
                                            disabled
                                            optionLabel="key"
                                            optionValue="value"
                                            placeholder="Please select one"
                                            class="custom-multiselect w-full"
                                        />
                                        </div>
                                        <div v-else class="text-sm">
                                            {{lablesData(riskThreatData.overallImpact,6)||'N/A'}}
                                        </div>
                                    </div>
                                    <h1 class="upperspacing">Revised Likelihood</h1>
                                    <div class="border-b pt-1 border-solid border-lightgrey"></div>
                                    <div class="row flex flex-row w-full upperspacing">
                                        <div class="w-6/12">
                                            <label class="controllabel">Likelihood</label> 

                                            <!-- <select
                                                class="inputboxstylingForSelect"
                                                v-model="riskThreatData.likelihood"
                                                :class="{
                                                    'is-invalid': v$.riskThreatData.likelihood.$error,'inputboxstylingForSelectAtPopup': riskThreatData.likelihood === '','stylingForInputboxstylingForSelectAtPopup': riskThreatData.likelihood !== ''
                                                }"
                                            >
                                                <option value="" selected hidden>Please select one</option>
                                                <option class="optionColors" v-for="i in dbLikelihood" :value="i.value" :key="i">
                                                    {{ i?.key }}
                                                </option>
                                            </select> -->
                                            <div v-if="riskThreatData.statusCode==10401|| addingRisk==true">
                                            <Select
                                                v-model="riskThreatData.likelihood"
                                                :options="dbLikelihood"
                                                optionLabel="key"
                                                optionValue="value"
                                                placeholder="Please select one"
                                                class="custom-multiselect w-full"
                                                :class="{
                                                   'is-invalid': v$.riskThreatData.likelihood.$error,
                                                   'inputboxstylingForSelectAtPopup': riskThreatData.likelihood === '',
                                                   'stylingForInputboxstylingForSelectAtPopup': riskThreatData.likelihood !== ''
                                                }"
                                            />
                                            <div v-if="v$.riskThreatData.likelihood.$error" class="text-red-500">
                                                <div class="error-text text-xs" v-if="v$.riskThreatData.likelihood.required.$invalid">Required</div>
                                            </div>
                                            </div>
                                            <div v-else-if="riskThreatData.residual && riskThreatData.residual.length > 0 && riskThreatData.action!=10419 && riskThreatData.statusCode!=10401" class="text-sm">
                                                {{ lablesData(riskThreatData.residual[riskThreatData.residual.length - 1]?.likelihood,5) || 'N/A'}}
                                            </div>
                                            <div v-else class="text-sm">
                                                {{lablesData(riskThreatData.likelihood,5)||'N/A'}}
                                            </div>
                                        </div>
                                       
                                    </div>  
                                    <div v-if="addingRisk!=true">
                                    <h1 class="upperspacing" >Risk Severity</h1>
                                    <div class="border-b pt-1 border-solid border-lightgrey"></div>
                                     <div class="w-6/12 upperspacing" >
                                        <label class="controllabel">Severity</label>
                                        <!-- <select class="inputboxstyling" disabled v-model="riskThreatData.overallImpact">
                                            <option value="" selected hidden>Please select one</option>
                                            <option v-for="i in dbOverAllImpact" :value="i.value" :key="i">
                                                {{ i.key }}
                                            </option>
                                        </select> -->
                                        <Select
                                            v-model="riskThreatData.severity"
                                            :options="dbSeverity"
                                            disabled
                                            optionLabel="key"
                                            optionValue="value"
                                            placeholder="Please select one"
                                            class="custom-multiselect w-full"
                                        />
                                    </div>      
                                    </div>                         
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="riskThreatData.statusCode==10401|| addingRisk==true">
                <div class="border-b border-solid border-lightgrey mx-5"></div>
                <div class="buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5">
                    <button :disabled="clickOnButton" class="btnprimary mr-2 gap-2" :class="disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none'" @click="onCancelRiskData()">Reset</button>
                    <button :disabled="clickOnButton" class="btnprimary mr-1.5" v-if="addingRisk" @click="addOrUpdaterisk(riskThreatData)" :class="disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none'">Save</button>
                    <button :disabled="clickOnButton" class="btnprimary mr-1.5" v-else @click="addOrUpdaterisk(riskThreatData)" :class="disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none'">Update</button>
                </div>
                </div>
            </div>
        </popup>
        <popup v-if="openRiskInformation" :popUp="openRiskInformation">
            <template v-slot:header>
                <div class="flex items-center justify-between popupheadingcontainer rounded">
                    <h1>Risk Information</h1>
                    <button class="float-right text-3xl" @click="onCrossbtn('close')">
                        <img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
                    </button>
                </div>
            </template>
                <div class='flex flex-col h-full'>
                    <div class="flex-1 overflow-auto">
                        <div  class="popup-business">
                        <div class="statuscontainer popupbodycontainer">
                            <div class="formcontainer flex flex-col">
                                <div>
                                    <div class="w-full upperspacing">
                                        <label class="controllabel">Risk</label>
                                        <div class="text-sm">{{riskThreatData.risk  != undefined ? riskThreatData.risk : 'N/A'}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="formcontainer flex flex-col upperspacing">
                                <div class="row flex flex-row w-full">
                                    <div class="w-6/12">
                                        <label class="controllabel">Risk Category</label>
                                        <div class="text-sm">{{riskThreatData.riskCategory  != undefined ? riskThreatData.riskCategory : 'N/A'}}</div>
                                    </div>
                                    <div class="w-3/6 leftspacing">
                                        <label class="controllabel">Risk Owner</label>
                                        <div class="text-sm">{{riskThreatData.riskOwner  != undefined ? riskThreatData.riskOwner : 'N/A'}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="formcontainer flex flex-col upperspacing">
                                <div>
                                    <div class="w-full">
                                        <label class="controllabel">Threat</label>
                                        <div class="text-sm">{{riskThreatData.threatEvent  != undefined ? riskThreatData.threatEvent : 'N/A'}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="formcontainer flex flex-col upperspacing">
                                <div class="row flex flex-row w-full">
                                    <div class="w-6/12">
                                        <label class="controllabel">Threat Source</label>
                                        <div class="text-sm">{{riskThreatData.threatSource  != undefined ? riskThreatData.threatSource : 'N/A'}}</div>
                                    </div>
                                    <div class="w-6/12 leftspacing">
                                        <label class="controllabel">Threat Category</label>
                                        <div class="text-sm">{{riskThreatData.threatCategory  != undefined ? riskThreatData.threatCategory : 'N/A'}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="formcontainer flex flex-col upperspacing">
                                <div>
                                    <div class="w-full">
                                        <label class="controllabel">Vulnerability</label>
                                        <div class="text-sm">{{riskThreatData.vulnerability  != undefined ? riskThreatData.vulnerability : 'N/A'}}</div>

                                    </div>
                                </div>
                            </div>
                            <h1 class="upperspacing">Impact Analysis</h1>
                            <div class="border-b mt-1 border-solid border-lightgrey"></div>

                            <div class="formcontainer flex flex-col upperspacing">
                                <div class="row flex flex-row w-full">
                                    <div class="w-6/12">
                                        <label class="controllabel">Strategic</label>
                                        <div class="text-sm">{{riskThreatData.business  != undefined ? dbOperations.find(a=>a.value==riskThreatData.business)?.key : 'N/A'}}</div>
                                    </div>

                                    <div class="w-6/12 leftspacing">
                                        <label class="controllabel">Financial</label>
                                        <div class="text-sm">{{riskThreatData.financial  != undefined ?  dbFinancial.find(a=>a.value==riskThreatData.business)?.key  : 'N/A'}}</div>
                                    </div>

                                    
                                </div>
                            </div>

                            <div class="formcontainer flex flex-col upperspacing">
                                <div class="row flex flex-row w-full">
                                    <div class="w-6/12">
                                        <label class="controllabel">Operations</label>
                                        <div class="text-sm">{{riskThreatData.operations  != undefined ? dbOperations.find(a=>a.value==riskThreatData.business)?.key : 'N/A'}}</div>

                                        
                                    </div>

                                    <div class="w-6/12 leftspacing">
                                        <label class="controllabel">Compliance</label>
                                        <div class="text-sm">{{riskThreatData.legal  != undefined ? dbLegal.find(a=>a.value==riskThreatData.business)?.key : 'N/A'}}</div>
                                    </div>
                                </div>
                            </div>

                        
                            <h1 class="upperspacing">Risk Analysis</h1>
                            <div class="border-b pt-1 border-solid border-lightgrey"></div>
                            <div class="formcontainer">
                                <div class="row flex flex-row w-full upperspacing">
                                    <div class="w-3/6">
                                        <label class="controllabel">Likelihood</label>
                                        <div class="text-sm">{{riskThreatData.likelihood  != undefined ? dbLikelihood.find(a=>a.value==riskThreatData.business)?.key : 'N/A'}}</div>
                                    </div>

                                     <div class="w-3/6 leftspacing">
                                        <label class="controllabel">Overall Impact</label>
                                        <div class="text-sm">{{riskThreatData.overallImpact  != undefined ? dbOverAllImpact.find(a=>a.value==riskThreatData.overallImpact)?.key : 'N/A'}}</div>
                                    </div> 
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div>
                    </div>
                </div>
        </popup>
        <popup v-if="showInformationPopup" :popUp="showInformationPopup">
            <template v-slot:header>
                <div class="flex items-center justify-between popupheadingcontainer rounded">
                    <h1>Information</h1>
                    <button class="float-right text-3xl" @click="onCloseInformation()">
                        <img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
                    </button>
                </div>
            </template>
                <div class='flex flex-col h-full'>
                    <div class="flex-1 overflow-auto">
                        <div class="popup-business">
                        <div class="statuscontainer popupbodycontainer">
                            <div class="formcontainer flex flex-col">
                                <div class="row flex flex-row w-full upperspacing">
                                    <div class="w-full" v-if="information.information != '' && !addInfo">
                                    <label class="controllabel">Information Category</label>
                                    <div class="text-sm">
                                        {{information.informationCategory}}
                                    </div>
                                    </div>
                                    <div class="w-full" v-else>
                                        <label class="controllabel">Information Category</label>
                                        <!-- <Multiselect
                                            v-model="information.informationCategory"
                                            :options="infoCategoryList"
                                            :multiple="false"
                                            :searchable="true"
                                            :hide-selected="true"
                                            open-direction="bottom"
                                            :close-on-select="true"
                                            :clear-on-select="true"
                                            :show-labels="false"
                                            class="custom-multiselect userSelect"
                                            @select="changeInfoCategory(information.informationCategory)"
                                            :disabled="!addInfo"
                                            placeholder="Information Category"
                                            :class="{
                                                'is-invalidmultiselect': v$.information.informationCategory.$error,
                                                'has-options': infoCategoryList && infoCategoryList.length > 0,
                                                'no-options':  !infoCategoryList.length,
                                            }"
                                        >
                                            <template v-slot:noResult>
                                                <span class="text-xs">No Categories Found</span>
                                            </template>
                                        </Multiselect> -->
                                        <Select
                                            v-model="information.informationCategory"
                                            :options="infoCategoryList"
                                            @select="changeInfoCategory(information.informationCategory)"
                                            placeholder="Information Category"
                                            class="custom-multiselect w-full"
                                            :class="{
                                                'is-invalid': v$.information.informationCategory.$error,
                                                'has-options': infoCategoryList && infoCategoryList.length > 0,
                                                'no-options':  !infoCategoryList.length,
                                            }"
                                        >
                                            <template #empty>
                                                <span class="text-xs">No Categories Found</span>
                                            </template>
                                        </Select>
                                        <div v-if="v$.information.informationCategory.$error" class="text-red-500">
                                            <div class="error-text text-xs" v-if="v$.information.informationCategory.required.$invalid">Required</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="w-full upperspacing">
                                    <div class="w-full" v-if="!addInfo">
                                        <label class="controllabel">Information</label>
                                        <div class="text-sm">{{information.information}}
                                        </div>
                                    </div>
                                    <div class="w-full" v-else>
                                        <label class="controllabel">Information</label>
                                        <!-- <Multiselect
                                            v-model="information.information"
                                            :options="infoList"
                                            :multiple="false"
                                            :searchable="true"
                                            :hide-selected="true"
                                            open-direction="bottom"
                                            :close-on-select="true"
                                            :show-labels="false"
                                            class="custom-multiselect"
                                            :disabled="!addInfo || information.informationCategory == ''"
                                            @select="changeInformation(information.information)"
                                            @deselect="changeInformation(information.information)"
                                            placeholder="Information"
                                            :class="{
                                                'is-invalidmultiselect': v$.information.information.$error,
                                                'has-options': infoList && infoList.length > 0,
                                                'no-options':  !infoList.length,
                                            }"
                                        >
                                            <template v-slot:noResult>
                                                <span class="text-xs">No Information Found</span>
                                            </template>
                                        </Multiselect> -->
                                        <Select
                                            v-model="information.information"
                                            :options="infoList"
                                            :disabled="!addInfo || information.informationCategory == ''"
                                            @change="changeInformation(information.information)"
                                            placeholder="Information Category"
                                            class="custom-multiselect w-full"
                                            :class="{
                                                'is-invalid': v$.information.information.$error,
                                                'has-options': infoList && infoList.length > 0,
                                                'no-options':  !infoList.length,
                                            }"
                                        >
                                            <template #empty>
                                                <span class="text-xs">No Categories Found</span>
                                            </template>
                                        </Select>
                                        <div v-if="v$.information.information.$error" class="text-red-500">
                                            <div class="error-text text-xs" v-if="v$.information.information.required.$invalid">Required</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row flex flex-row w-full upperspacing">
                                    <div class="w-6/12" v-if="information.information != '' && !addInfo">
                                        <label class="controllabel">Information Owner</label>
                                        <div class="text-sm">
                                            {{information.informationOwner.label}}
                                        </div>
                                    </div>
                                    <div class="w-6/12" v-else>
                                        <label class="controllabel">Information Owner</label>
                                        <!-- <Multiselect
                                            v-model="information.informationOwner"
                                            :options="optionsUserArray"
                                            :multiple="false"
                                            :close-on-select="true"
                                            :clear-on-select="true"
                                            label="label"
                                            track-by="value"
                                            :searchable="true"
                                            :hideArrow="false"
                                            deselectLabel=""
                                            selectLabel=""
                                            class="custom-multiselect"
                                            disabled
                                            placeholder="Information Owner"
                                            
                                        ></Multiselect> -->
                                        <Select
                                            v-model="information.informationOwner"
                                            :options="optionsUserArray"
                                            optionLabel="label"
                                            optionValue="value"
                                            disabled
                                            placeholder="Information Owner"
                                            class="custom-multiselect w-full"
                                        >
                                            <template #empty>
                                                <span class="text-xs">No Categories Found</span>
                                            </template>
                                        </Select>

                                        <!-- :class="{
                                                'is-invalid borderRed': v$.information.informationOwner.$error
                                            }"
                                        <div v-if="v$.information.informationOwner.$error" class="text-red-500">
                                            <div class="error-text text-xs" v-if="v$.information.informationOwner.required.$invalid">Required</div>
                                        </div> -->
                                    </div>
                                    <div class="w-6/12" :class="information._id ? '' : 'leftspacing'" v-if="this.addInfoMethod.confidentiality == information.confidentiality || !addInfo || !addCIAInfo">
                                        <label class="controllabel">Confidentiality</label>
                                        <div v-for="(dataValue, indexNum) in dbConfidentiality" :key="indexNum">
                                            <div v-if="information.confidentiality == dataValue.value">
                                                <div class="text-sm">{{dataValue.key}}</div>
                                                <!-- <input type="text" class="inputboxstyling" disabled v-model="dataValue.key" placeholder="Security Category" /> -->
                                            </div>
                                        </div>
                                    </div>
                                    <div class="w-6/12 leftspacing" v-else>
                                        <label class="controllabel">Confidentiality</label>
                                        <!-- <select
                                            v-on:change="getMaxIdValue()"
                                            class="disabledinputboxstyling disabledselect inputboxstyling"
                                            disabled
                                            v-model="information.confidentiality"
                                            
                                        >
                                            <option value="" selected disabled hidden>Confidentiality</option>
                                            <option v-for="obj in dbConfidentiality" :key="obj" :value="obj.value">{{ obj.key }}</option>
                                        </select> -->
                                        <Select
                                            v-model="information.confidentiality"
                                            :options="dbConfidentiality"
                                            disabled
                                            optionLabel="key"
                                            optionValue="value"
                                            placeholder="Please select one"
                                            @change="getMaxIdValue()"
                                            class="custom-multiselect w-full"
                                        />

                                        <!-- :class="{
                                                'is-invalid': v$.information.confidentiality.$error
                                            }"
                                        <div v-if="v$.information.confidentiality.$error" class="text-red-500">
                                            <div class="error-text text-xs" v-if="v$.information.confidentiality.required.$invalid">Required</div>
                                        </div> -->
                                    </div>
                                </div>
                                <div class="row flex flex-row w-full upperspacing">
                                    <div class="w-6/12" v-if="this.addInfoMethod.integrity == information.integrity || !addInfo || !addCIAInfo">
                                        <label class="controllabel">Integrity</label>
                                        <div v-for="(dataValue, indexNum) in dbIntegrity" :key="indexNum">
                                            <div v-if="information.integrity == dataValue.value">
                                                 <div class="text-sm">{{dataValue.key}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="w-6/12" v-else>
                                        <label class="controllabel">Integrity</label>
                                        <!-- <select
                                            v-on:change="getMaxIdValue()"
                                            class="disabledinputboxstyling disabledselect inputboxstyling"
                                            disabled
                                            v-model="information.integrity"
                                            
                                        >
                                            <option value="" selected disabled hidden>Integrity</option>
                                            <option v-for="obj in dbIntegrity" :key="obj" :value="obj.value">{{ obj.key }}</option>
                                        </select> -->
                                        <Select
                                            v-model="information.integrity"
                                            :options="dbIntegrity"
                                            disabled
                                            optionLabel="key"
                                            optionValue="value"
                                            placeholder="Please select one"
                                            @change="getMaxIdValue()"
                                            class="custom-multiselect w-full"
                                        />

                                        <!-- :class="{
                                                'is-invalid': v$.information.integrity.$error
                                            }"
                                        <div v-if="v$.information.integrity.$error" class="text-red-500">
                                            <div class="error-text text-xs" v-if="v$.information.integrity.required.$invalid">Required</div>
                                        </div> -->
                                    </div>
                                    <div class="w-6/12" :class="information._id ? '' : 'leftspacing'" v-if="this.addInfoMethod.availability == information.availability || !addInfo || !addCIAInfo">
                                        <label class="controllabel">Availability</label>
                                        <div v-for="(dataValue, indexNum) in dbAvailability" :key="indexNum">
                                            <div v-if="information.availability == dataValue.value">
                                                 <div class="text-sm">{{dataValue.key}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="w-6/12 leftspacing" v-else>
                                        <label class="controllabel">Availability</label>
                                        <!-- <select
                                            v-on:change="getMaxIdValue()"
                                            class="disabledinputboxstyling disabledselect inputboxstyling"
                                            v-model="information.availability"
                                            disabled
                                            
                                        >
                                            <option value="" selected disabled hidden>Availability</option>
                                            <option v-for="obj in dbAvailability" :key="obj" :value="obj.value">{{ obj.key }}</option>
                                        </select> -->
                                        <Select
                                            v-model="information.availability"
                                            :options="dbAvailability"
                                            disabled
                                            optionLabel="key"
                                            optionValue="value"
                                            placeholder="Please select one"
                                            @change="getMaxIdValue()"
                                            class="custom-multiselect w-full"
                                        />
                                        
                                        <!-- :class="{
                                                'is-invalid': v$.information.availability.$error
                                            }"
                                        <div v-if="v$.information.availability.$error" class="text-red-500">
                                            <div class="error-text text-xs" v-if="v$.information.availability.required.$invalid">Required</div>
                                        </div> -->
                                    </div>
                                </div>
                                <div class="row flex flex-row w-full upperspacing">
                                    <div class="w-6/12" v-if="information.classification != '' || !addInfo">
                                        <label class="controllabel">Classification</label>
                                        <div v-for="(dataValue, indexNum) in dbInformationClassification" :key="indexNum">
                                            <div v-if="information.classification == dataValue.value">
                                                 <div class="text-sm">{{dataValue.key}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="w-6/12" v-else>
                                        <label class="controllabel">Classification</label> 
                                        <!-- <select
                                            class="disabledinputboxstyling disabledselect inputboxstyling"
                                            v-model="information.classification"
                                            placeholder="Classification"
                                            disabled
                                            :class="{
                                                'is-invalid': v$.information.classification.$error
                                            }"
                                        >
                                            <option value="" selected disabled hidden>Classification</option>
                                            <option v-for="obj in dbInformationClassification" :key="obj" :value="obj.value">{{ obj.key }}</option>
                                        </select> -->
                                        <Select
                                            v-model="information.classification"
                                            :options="dbInformationClassification"
                                            disabled
                                            optionLabel="key"
                                            optionValue="value"
                                            placeholder="Please select one"
                                            @change="getMaxIdValue()"
                                            class="custom-multiselect w-full"
                                            :class="{
                                                'is-invalid': v$.information.classification.$error
                                            }"
                                        />

                                        <div v-if="v$.information.classification.$error" class="text-red-500">
                                            <div class="error-text text-xs" v-if="v$.information.classification.required.$invalid">Required</div>
                                        </div>
                                    </div>
                                    <div class="w-6/12" v-if="information.securityCategory != '' && !addInfo">
                                        <div v-for="(dataValue, indexNum) in dbSecurityCategory" :key="indexNum">
                                            <div v-if="information.securityCategory == dataValue.value">
                                                <label class="controllabel">Security Category</label>
                                                <div class="text-sm">{{dataValue.key}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                        
                        <div class="border-b mx-4 border-solid border-lightgrey" v-if="addInformationObj.length > 0"></div>
                        <div class="flex flex-row px-4 justify-between" v-for="(info, index) in addInformationObj" :key="info">
                            <div class="statuscontainer w-11/12 my-2 border-solid border border-lightgrey rounded p-2" v-if="addInformationObj.length > 0">
                                <div class="text-sm font-light text-gray bg-white">
                                    <ul>
                                        <li class="text-sm flex flex-row items-center justify-between">
                                            {{ info.information }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="flex justify-center items-center">
                                <button class="float-right" @click="onInfoDelete(index)">
                                    <img src="@/assets/deleteIcon.svg" class="h-5 w-5 cursor-pointer" />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div>
                    <div v-if="addInfo">
                    <div class="border-b border-solid border-lightgrey mx-5"></div>
                    <div class="buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5">
                        <button class="btnprimary mr-1.5" :class="disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none'" @click="onCancelbtn(information)">Reset</button>
                        <button @click="addInformationToObject()" :class="disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none'">Add</button>
                    </div>
                    </div>
                    <div class="border-b border-solid border-lightgrey mx-5"></div>
                    <div class="buttonposition flex justify-center items-center mb-4 mx-0" v-if="addInformationObj.length > 0">
                        <button class="btnprimary mr-1.5" @click="onResetbtn(information)">Reset</button>
                        <button class="btnprimary" @click="saveInformation()">Save</button>
                    </div>
                    </div>
                </div>
        </popup>

        <popup class="applyPopup" v-if="applyPopup" :popUp="applyPopup">
            <div class="flex flex-col h-full">
                <div class="flex-1 overflow-auto">
                    <!--content-->
                    <div class="border-0 rounded relative flex flex-col w-full bg-white risksAcceptance h-screen">
                        <!--header-->
                        <div class="flex items-center justify-between p-3 rounded popupheadingcontainer">
                            <h1 v-if="thisScreen == 'Acceptance'">Risk Accept</h1>
                            <h1 v-if="thisScreen == 'reset'">Risk Reset</h1>
                            <h1 v-if="thisScreen == 'deactive'">Risk Invalid</h1>
                            <h1 v-if="thisScreen == 'Avoid'">Risk Avoid</h1>
                            <h1 v-if="thisScreen == 'Transfer'">Risk Transfer</h1>
                            <h1 v-if="thisScreen == 'Monitered'">Risk Moniter</h1>
                            <button class="p-1 ml-auto float-right text-3xl leading-none font-semibold outline-none focus:outline-none" @click="onCrossbtn()">
                                <!-- <XIcon class="h-5 w-5" /> -->
                                <img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
                            </button>
                        </div>
                        <div class="border-b border-solid border-lightgrey ml-4 mr-4"></div>
                        <div>
                            <div class="impactcontainer popupbodycontainer">
                                <div class="formcontainer flex flex-col">
                                    <div class="row flex flex-col">
                                        <div class="upperspacing">
                                            <label class="controllabel">Systems</label>
                                            <div class="text-xs flex flex-wrap">
                                                <div v-for="system in mainSystem" :key="system" class="mr-2 mb-2 px-2 py-1 bg-primary text-white rounded">
                                                    {{ mappedSystemsOptions.find(option => option.value === mainSystem[0])?.label || "-" }}
                                                </div>
                                                <div v-if="mainSystem.length === 0">No Systems selected</div>
                                            </div>
                                            <!-- <Multiselect 
                                                v-model="mainSystem"
                                                :options="mappedSystemsOptions" 
                                                :multiple="false"
                                                :close-on-select="true"
                                                :clear-on-select="true"
                                                label="label"
                                                track-by="value"
                                                :searchable="true"
                                                :hideArrow="false"
                                                deselectLabel=""
                                                selectLabel=""
                                                class="custom-multiselect"
                                                :disabled=true
                                                placeholder="Systems">
                                            </Multiselect> -->
                                        </div>
                                        <div class="border-b border-solid border-lightgrey mt-4"></div>
                                        <div class="w-full upperspacing">
                                            <label v-if="thisScreen == 'Acceptance'" class="controllabel">Treatment Summary for Accepting Risk</label>
                                            <label v-if="thisScreen == 'reset'" class="controllabel">Treatment Summary for Reset Risk</label>
                                            <label v-if="thisScreen == 'deactive'" class="controllabel">Treatment Summary for Invalid Risk</label>
                                            <label v-if="thisScreen == 'Avoid'" class="controllabel">Treatment Summary for Avoid Risk </label>
                                            <label v-if="thisScreen == 'Transfer'" class="controllabel">Treatment Summary for Transfer Risk </label>
                                            <label v-if="thisScreen == 'Monitered'" class="controllabel">Treatment Summary for Monitered Risk</label>
                                            <textarea type="text" class="inputboxstyling h-20 max-h-48" v-model.trim="applyObj.comments" placeholder="Treatment Summary" :class="{
                                                    'is-invalid': (v$.applyObj.comments.$error)
                                                }">
                                            </textarea>
                                             <div v-if="v$.applyObj.comments.$error" class="text-red-500">
                                                <div class="error-text text-xs" v-if="v$.applyObj.comments.required.$invalid">Required</div>
                                            </div>
                                        </div>
                                        <div v-if="thisScreen!='Avoid' && thisScreen!='reset' && thisScreen!='deactive' && (thisScreen!='Monitered' && residualData.statusCode!=10425)">
                                        <h1 class="upperspacing">Revised Impact</h1>
                                        <div class="border-b pt-1 border-solid border-lightgrey"></div>

                                        <div class="row flex flex-row w-full upperspacing">
                                            <div class="col-md-6 w-6/12">
                                                <label class="controllabel">Strategic</label>

                                                <!-- <select
                                                    class="inputboxstylingForSelect"
                                                    v-model="riskThreatData.business"
                                                    :class="{
                                                        'is-invalid': v$.riskThreatData.business.$error,'inputboxstylingForSelectAtPopup': riskThreatData.business === '','stylingForInputboxstylingForSelectAtPopup': riskThreatData.business !== ''
                                                    }"
                                                    @change="calculateOverallImpact()"
                                                >
                                                    <option value="" selected disabled hidden>Please select one</option>

                                                    <option class="optionColors" v-for="option in dbBussiness" :key="option" :value="option.value">
                                                            {{ option?.key }}
                                                        </option>
                                                </select> -->
                                                <Select
                                                    v-model="residualData.business"
                                                    :options="dbBussiness"
                                                    optionLabel="key"
                                                    optionValue="value"
                                                    placeholder="Please select one"
                                                    @change="calculateOverallImpact()"
                                                    :disabled="thisScreen=='Acceptance'"
                                                    class="custom-multiselect w-full"
                                                    :class="{
                                                        'is-invalid': v$.residualData.business.$error,
                                                        'inputboxstylingForSelectAtPopup': residualData.business === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': residualData.business !== ''
                                                    }"
                                                />
                                                <div v-if="v$.residualData.business.$error" class="text-red-500">
                                                    <div class="error-text text-xs" v-if="v$.residualData.business.required.$invalid">Required</div>
                                                </div>
                                            </div>

                                            <div class="col-md-6 w-6/12 leftspacing">
                                                <label class="controllabel">Financial</label>

                                                <!-- <select
                                                    class="inputboxstylingForSelect"
                                                    v-model="riskThreatData.financial"
                                                    :class="{
                                                        'is-invalid': v$.riskThreatData.financial.$error,'inputboxstylingForSelectAtPopup': riskThreatData.financial === '','stylingForInputboxstylingForSelectAtPopup': riskThreatData.financial !== ''
                                                    }"
                                                    @change="calculateOverallImpact()"
                                                >
                                                    <option value="" selected disabled hidden>Please select one</option>

                                                    <option class="optionColors" v-for="option in dbFinancial" :key="option" :value="option.value">
                                                            {{ option?.key }}
                                                        </option>
                                                </select> -->
                                                <Select
                                                    v-model="residualData.financial"
                                                    :options="dbFinancial"
                                                    optionLabel="key"
                                                    optionValue="value"
                                                    placeholder="Please select one"
                                                    :disabled="thisScreen=='Acceptance'"
                                                    @change="calculateOverallImpact()"
                                                    class="custom-multiselect w-full"
                                                    :class="{
                                                        'is-invalid': v$.residualData.business.$error,
                                                        'inputboxstylingForSelectAtPopup': residualData.business === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': residualData.business !== ''
                                                    }"
                                                />
                                                <div v-if="v$.residualData.financial.$error" class="text-red-500">
                                                    <div class="error-text text-xs" v-if="v$.residualData.financial.required.$invalid">Required</div>
                                                </div>
                                            </div>

                                            
                                        </div>

                                        <div class="row flex flex-row w-full upperspacing">
                                            <div class="col-md-6 w-6/12">
                                                <label class="controllabel">Operations</label>

                                                <!-- <select
                                                    class="inputboxstylingForSelect"
                                                    v-model="riskThreatData.operations"
                                                    :class="{
                                                        'is-invalid': v$.riskThreatData.operations.$error,'inputboxstylingForSelectAtPopup': riskThreatData.operations === '','stylingForInputboxstylingForSelectAtPopup': riskThreatData.operations !== ''
                                                    }"
                                                    @change="calculateOverallImpact()"
                                                >
                                                    <option value="" selected disabled hidden>Please select one</option>

                                                    <option class="optionColors" v-for="option in dbOperations" :key="option" :value="option.value">
                                                        {{ option?.key }}
                                                    </option>
                                                </select> -->
                                                <Select
                                                    v-model="residualData.operations"
                                                    :options="dbOperations"
                                                    optionLabel="key"
                                                    optionValue="value"
                                                    placeholder="Please select one"
                                                    :disabled="thisScreen=='Acceptance'"
                                                    @change="calculateOverallImpact()"
                                                    class="custom-multiselect w-full"
                                                    :class="{
                                                        'is-invalid': v$.residualData.operations.$error,
                                                        'inputboxstylingForSelectAtPopup': residualData.operations === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': residualData.operations !== ''
                                                    }"
                                                />
                                                <div v-if="v$.residualData.operations.$error" class="text-red-500">
                                                    <div class="error-text text-xs" v-if="v$.residualData.operations.required.$invalid">Required</div>
                                                </div>
                                            </div>

                                            <div class="col-md-6 w-6/12 leftspacing">
                                                <label class="controllabel">Compliance</label>

                                                <!-- <select
                                                    class="inputboxstylingForSelect"
                                                    v-model="riskThreatData.legal"
                                                    :class="{
                                                        'is-invalid': v$.riskThreatData.legal.$error,'inputboxstylingForSelectAtPopup': riskThreatData.legal === '','stylingForInputboxstylingForSelectAtPopup': riskThreatData.legal !== ''
                                                    }"
                                                    @change="calculateOverallImpact()"
                                                >
                                                    <option value="" selected disabled hidden>Please select one</option>

                                                    <option class="optionColors" v-for="option in dbLegal" :key="option" :value="option.value">
                                                            {{ option?.key }}
                                                        </option>
                                                </select> -->
                                                <Select
                                                    v-model="residualData.legal"
                                                    :options="dbLegal"
                                                    optionLabel="key"
                                                    optionValue="value"
                                                    placeholder="Please select one"
                                                    @change="calculateOverallImpact()"
                                                    :disabled="thisScreen=='Acceptance'"
                                                    class="custom-multiselect w-full"
                                                    :class="{
                                                        'is-invalid': v$.residualData.legal.$error,
                                                        'inputboxstylingForSelectAtPopup': residualData.legal === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': residualData.legal !== ''
                                                    }"
                                                />
                                                <div v-if="v$.residualData.legal.$error" class="text-red-500">
                                                    <div class="error-text text-xs" v-if="v$.residualData.legal.required.$invalid">Required</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="w-6/12 upperspacing">
                                            <label class="controllabel">Overall Impact</label>
                                            <!-- <select class="inputboxstyling" disabled v-model="riskThreatData.overallImpact">
                                                <option value="" selected hidden>Please select one</option>
                                                <option v-for="i in dbOverAllImpact" :value="i.value" :key="i">
                                                    {{ i.key }}
                                                </option>
                                            </select> -->
                                            <Select
                                                v-model="residualData.overallImpact"
                                                :options="dbOverAllImpact"
                                                disabled
                                                optionLabel="key"
                                                optionValue="value"
                                                placeholder="Please select one"
                                                class="custom-multiselect w-full"
                                            />
                                        </div>
                                        <h1 class="upperspacing">Revised Likelihood</h1>
                                        <div class="border-b pt-1 border-solid border-lightgrey"></div>

                                        <div class="row flex flex-row w-full upperspacing">
                                            
                                                <div class="w-6/12">
                                                <label class="controllabel">Likelihood</label>

                                                <!-- <select
                                                    class="inputboxstylingForSelect"
                                                    v-model="riskThreatData.likelihood"
                                                    :class="{
                                                        'is-invalid': v$.riskThreatData.likelihood.$error,'inputboxstylingForSelectAtPopup': riskThreatData.likelihood === '','stylingForInputboxstylingForSelectAtPopup': riskThreatData.likelihood !== ''
                                                    }"
                                                >
                                                    <option value="" selected disabled hidden>Please select one</option>

                                                    <option class="optionColors" v-for="option in dbLikelihood" :key="option" :value="option.value">
                                                            {{ option?.key }}
                                                        </option>
                                                </select> -->
                                                <Select
                                                    v-model="residualData.likelihood"
                                                    :options="dbLikelihood"
                                                    optionLabel="key"
                                                    optionValue="value"
                                                    :disabled="thisScreen=='Acceptance'"
                                                    @change="calculateOverallImpact()"
                                                    placeholder="Please select one"
                                                    class="custom-multiselect w-full"
                                                    :class="{
                                                        'is-invalid': v$.residualData.likelihood.$error,
                                                        'inputboxstylingForSelectAtPopup': residualData.likelihood === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': residualData.likelihood !== ''
                                                    }"
                                                />
                                                <div v-if="v$.residualData.likelihood.$error" class="text-red-500">
                                                    <div class="error-text text-xs" v-if="v$.residualData.likelihood.required.$invalid">Required</div>
                                                </div>
                                                </div>                                                
                                        </div>
                                        <h1 class="upperspacing">Risk Severity</h1>
                                        <div class="border-b pt-1 border-solid border-lightgrey"></div>
                                            <div class="w-6/12 upperspacing">
                                                <label class="controllabel">Severity</label>
                                                <!-- <select class="inputboxstyling" disabled v-model="riskThreatData.overallImpact">
                                                    <option value="" selected hidden>Please select one</option>
                                                    <option v-for="i in dbOverAllImpact" :value="i.value" :key="i">
                                                        {{ i.key }}
                                                    </option>
                                                </select> -->
                                                <Select
                                                    v-model="residualData.severity"
                                                    :options="dbSeverity"
                                                    disabled
                                                    optionLabel="key"
                                                    optionValue="value"
                                                    placeholder="Please select one"
                                                    class="custom-multiselect w-full"
                                                />
                                            </div>
                                    </div>
                                    <div v-else-if="(thisScreen=='Monitered' && residualData.statusCode==10425)">
                                        <h1 class="upperspacing">Revised Impact</h1>
                                        <div class="border-b pt-1 border-solid border-lightgrey"></div>

                                        <div class="row flex flex-row w-full upperspacing">
                                            <div class="col-md-6 w-6/12">
                                                <label class="controllabel">Strategic</label>

                                                <!-- <select
                                                    class="inputboxstylingForSelect"
                                                    v-model="riskThreatData.business"
                                                    :class="{
                                                        'is-invalid': v$.riskThreatData.business.$error,'inputboxstylingForSelectAtPopup': riskThreatData.business === '','stylingForInputboxstylingForSelectAtPopup': riskThreatData.business !== ''
                                                    }"
                                                    @change="calculateOverallImpact()"
                                                >
                                                    <option value="" selected disabled hidden>Please select one</option>

                                                    <option class="optionColors" v-for="option in dbBussiness" :key="option" :value="option.value">
                                                            {{ option?.key }}
                                                        </option>
                                                </select> -->
                                                <Select
                                                    v-model="residualData.business"
                                                    :options="dbBussiness"
                                                    optionLabel="key"
                                                    optionValue="value"
                                                    placeholder="Please select one"
                                                    @change="calculateOverallImpact()"
                                                    :disabled="thisScreen=='Acceptance'"
                                                    class="custom-multiselect w-full"
                                                    :class="{
                                                        'is-invalid': v$.residualData.business.$error,
                                                        'inputboxstylingForSelectAtPopup': residualData.business === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': residualData.business !== ''
                                                    }"
                                                />
                                                <div v-if="v$.residualData.business.$error" class="text-red-500">
                                                    <div class="error-text text-xs" v-if="v$.residualData.business.required.$invalid">Required</div>
                                                </div>
                                            </div>

                                            <div class="col-md-6 w-6/12 leftspacing">
                                                <label class="controllabel">Financial</label>

                                                <!-- <select
                                                    class="inputboxstylingForSelect"
                                                    v-model="riskThreatData.financial"
                                                    :class="{
                                                        'is-invalid': v$.riskThreatData.financial.$error,'inputboxstylingForSelectAtPopup': riskThreatData.financial === '','stylingForInputboxstylingForSelectAtPopup': riskThreatData.financial !== ''
                                                    }"
                                                    @change="calculateOverallImpact()"
                                                >
                                                    <option value="" selected disabled hidden>Please select one</option>

                                                    <option class="optionColors" v-for="option in dbFinancial" :key="option" :value="option.value">
                                                            {{ option?.key }}
                                                        </option>
                                                </select> -->
                                                <Select
                                                    v-model="residualData.financial"
                                                    :options="dbFinancial"
                                                    optionLabel="key"
                                                    optionValue="value"
                                                    placeholder="Please select one"
                                                    :disabled="thisScreen=='Acceptance'"
                                                    @change="calculateOverallImpact()"
                                                    class="custom-multiselect w-full"
                                                    :class="{
                                                        'is-invalid': v$.residualData.business.$error,
                                                        'inputboxstylingForSelectAtPopup': residualData.business === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': residualData.business !== ''
                                                    }"
                                                />
                                                <div v-if="v$.residualData.financial.$error" class="text-red-500">
                                                    <div class="error-text text-xs" v-if="v$.residualData.financial.required.$invalid">Required</div>
                                                </div>
                                            </div>

                                            
                                        </div>

                                        <div class="row flex flex-row w-full upperspacing">
                                            <div class="col-md-6 w-6/12">
                                                <label class="controllabel">Operations</label>

                                                <!-- <select
                                                    class="inputboxstylingForSelect"
                                                    v-model="riskThreatData.operations"
                                                    :class="{
                                                        'is-invalid': v$.riskThreatData.operations.$error,'inputboxstylingForSelectAtPopup': riskThreatData.operations === '','stylingForInputboxstylingForSelectAtPopup': riskThreatData.operations !== ''
                                                    }"
                                                    @change="calculateOverallImpact()"
                                                >
                                                    <option value="" selected disabled hidden>Please select one</option>

                                                    <option class="optionColors" v-for="option in dbOperations" :key="option" :value="option.value">
                                                        {{ option?.key }}
                                                    </option>
                                                </select> -->
                                                <Select
                                                    v-model="residualData.operations"
                                                    :options="dbOperations"
                                                    optionLabel="key"
                                                    optionValue="value"
                                                    placeholder="Please select one"
                                                    :disabled="thisScreen=='Acceptance'"
                                                    @change="calculateOverallImpact()"
                                                    class="custom-multiselect w-full"
                                                    :class="{
                                                        'is-invalid': v$.residualData.operations.$error,
                                                        'inputboxstylingForSelectAtPopup': residualData.operations === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': residualData.operations !== ''
                                                    }"
                                                />
                                                <div v-if="v$.residualData.operations.$error" class="text-red-500">
                                                    <div class="error-text text-xs" v-if="v$.residualData.operations.required.$invalid">Required</div>
                                                </div>
                                            </div>

                                            <div class="col-md-6 w-6/12 leftspacing">
                                                <label class="controllabel">Compliance</label>

                                                <!-- <select
                                                    class="inputboxstylingForSelect"
                                                    v-model="riskThreatData.legal"
                                                    :class="{
                                                        'is-invalid': v$.riskThreatData.legal.$error,'inputboxstylingForSelectAtPopup': riskThreatData.legal === '','stylingForInputboxstylingForSelectAtPopup': riskThreatData.legal !== ''
                                                    }"
                                                    @change="calculateOverallImpact()"
                                                >
                                                    <option value="" selected disabled hidden>Please select one</option>

                                                    <option class="optionColors" v-for="option in dbLegal" :key="option" :value="option.value">
                                                            {{ option?.key }}
                                                        </option>
                                                </select> -->
                                                <Select
                                                    v-model="residualData.legal"
                                                    :options="dbLegal"
                                                    optionLabel="key"
                                                    optionValue="value"
                                                    placeholder="Please select one"
                                                    @change="calculateOverallImpact()"
                                                    :disabled="thisScreen=='Acceptance'"
                                                    class="custom-multiselect w-full"
                                                    :class="{
                                                        'is-invalid': v$.residualData.legal.$error,
                                                        'inputboxstylingForSelectAtPopup': residualData.legal === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': residualData.legal !== ''
                                                    }"
                                                />
                                                <div v-if="v$.residualData.legal.$error" class="text-red-500">
                                                    <div class="error-text text-xs" v-if="v$.residualData.legal.required.$invalid">Required</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="w-6/12 upperspacing">
                                            <label class="controllabel">Overall Impact</label>
                                            <!-- <select class="inputboxstyling" disabled v-model="riskThreatData.overallImpact">
                                                <option value="" selected hidden>Please select one</option>
                                                <option v-for="i in dbOverAllImpact" :value="i.value" :key="i">
                                                    {{ i.key }}
                                                </option>
                                            </select> -->
                                            <Select
                                                v-model="residualData.overallImpact"
                                                :options="dbOverAllImpact"
                                                disabled
                                                optionLabel="key"
                                                optionValue="value"
                                                placeholder="Please select one"
                                                class="custom-multiselect w-full"
                                            />
                                        </div>
                                        <h1 class="upperspacing">Revised Likelihood</h1>
                                        <div class="border-b pt-1 border-solid border-lightgrey"></div>

                                        <div class="row flex flex-row w-full upperspacing">
                                            
                                                <div class="w-6/12">
                                                <label class="controllabel">Likelihood</label>

                                                <!-- <select
                                                    class="inputboxstylingForSelect"
                                                    v-model="riskThreatData.likelihood"
                                                    :class="{
                                                        'is-invalid': v$.riskThreatData.likelihood.$error,'inputboxstylingForSelectAtPopup': riskThreatData.likelihood === '','stylingForInputboxstylingForSelectAtPopup': riskThreatData.likelihood !== ''
                                                    }"
                                                >
                                                    <option value="" selected disabled hidden>Please select one</option>

                                                    <option class="optionColors" v-for="option in dbLikelihood" :key="option" :value="option.value">
                                                            {{ option?.key }}
                                                        </option>
                                                </select> -->
                                                <Select
                                                    v-model="residualData.likelihood"
                                                    :options="dbLikelihood"
                                                    optionLabel="key"
                                                    optionValue="value"
                                                    :disabled="thisScreen=='Acceptance'"
                                                    @change="calculateOverallImpact()"
                                                    placeholder="Please select one"
                                                    class="custom-multiselect w-full"
                                                    :class="{
                                                        'is-invalid': v$.residualData.likelihood.$error,
                                                        'inputboxstylingForSelectAtPopup': residualData.likelihood === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': residualData.likelihood !== ''
                                                    }"
                                                />
                                                <div v-if="v$.residualData.likelihood.$error" class="text-red-500">
                                                    <div class="error-text text-xs" v-if="v$.residualData.likelihood.required.$invalid">Required</div>
                                                </div>
                                                </div>                                                
                                        </div>
                                        <h1 class="upperspacing">Risk Severity</h1>
                                        <div class="border-b pt-1 border-solid border-lightgrey"></div>
                                            <div class="w-6/12 upperspacing">
                                                <label class="controllabel">Severity</label>
                                                <!-- <select class="inputboxstyling" disabled v-model="riskThreatData.overallImpact">
                                                    <option value="" selected hidden>Please select one</option>
                                                    <option v-for="i in dbOverAllImpact" :value="i.value" :key="i">
                                                        {{ i.key }}
                                                    </option>
                                                </select> -->
                                                <Select
                                                    v-model="residualData.severity"
                                                    :options="dbSeverity"
                                                    disabled
                                                    optionLabel="key"
                                                    optionValue="value"
                                                    placeholder="Please select one"
                                                    class="custom-multiselect w-full"
                                                />
                                            </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--footer-->
                    </div>
                </div>
                <div class="border-b border-solid border-lightgrey upperspacing"></div>
                <div class="buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5">
                    <button :disabled="clickOnButton" @click="cancelAceeptResetBtn()" :class="applyObj.comments == '' && (JSON.stringify(residualData) == JSON.stringify(dummyresidualData)) ? 'btndisabled pointer-events-none' : 'btnprimary'" class="mr-3">Reset</button>
                    <button :disabled="clickOnButton" v-if="thisScreen == 'Acceptance'" :class="applyObj.comments == '' ? 'btndisabled pointer-events-none' : 'btnprimary'" @click="createTaskForAction(applyObj, 10403)">Apply</button>
                    <button :disabled="clickOnButton" v-if="thisScreen == 'Avoid'" :class="applyObj.comments == '' ? 'btndisabled pointer-events-none' : 'btnprimary'" @click="createTaskForAction(applyObj, 10419)">Apply</button>
                    <button :disabled="clickOnButton" v-if="thisScreen == 'Transfer'" :class="applyObj.comments == '' && (JSON.stringify(residualData) == JSON.stringify(dummyresidualData)) ? 'btndisabled pointer-events-none' : 'btnprimary'" @click="createTaskForAction(applyObj, 10424)">Apply</button>
                    <button :disabled="clickOnButton" v-if="thisScreen == 'Monitered'" :class="applyObj.comments == '' && (JSON.stringify(residualData) == JSON.stringify(dummyresidualData)) ? 'btndisabled pointer-events-none' : 'btnprimary'" @click="createTaskForAction(applyObj, 10425)">Apply</button>
                    <button :disabled="clickOnButton" v-if="thisScreen == 'reset'" :class="applyObj.comments == '' ? 'btndisabled pointer-events-none' : 'btnprimary'" class="btnprimary" @click="createTaskForAction(applyObj, 10407)">Apply</button>
                    <button :disabled="clickOnButton" v-if="thisScreen == 'deactive'" :class="applyObj.comments == '' ? 'btndisabled pointer-events-none' : 'btnprimary'" class="btnprimary" @click="createTaskForAction(applyObj, 10404)">Apply</button>
                </div>
                
                </div>
        </popup>

        <popup v-if="showPriorityPopUp">
            <template v-slot:header>
                <div class="flex items-center justify-between popupheadingcontainer rounded">
                    <h1>Risk Prioritize</h1>

                    <button class="float-right text-3xl" @click="closePriorityPopup()">
                        <img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
                    </button>
                </div>
            </template>

            <div class='flex flex-col h-full'>
                <div class="flex-1 overflow-auto popupbodycontainer">
                    <div class="w-full upperspacing">
                        <label class="controllabel font-normal text-sm mb-1" for="vulnerability">Risk Name</label> 
                        <input
                            v-model="riskPriorityShow.risk"
                            disabled
                            placeholder="Name of the Risk"
                            id="id"
                            class="disabledinputboxstyling"
                            :class="{
                                'is-invalid': v$.riskPriorityShow.risk.$error
                            }"
                        />
                        <div class="text-red-500" v-if="v$.riskPriorityShow.risk.$error">
                            <div v-if="v$.riskPriorityShow.risk.required.$invalid" class="error-text text-xs">Risk name is required</div>
                        </div>
                    </div>

                    <div class="w-1/2 upperspacing">
                        <label class="controllabel">Priority</label>
                        <!-- <select class="inputboxstyling" placeholder="Priority" v-model="riskPriorityShow.priority">
                            <option v-for="(priority, index) in dbPriority" :key="index" :value="priority.value">{{ priority.key }}</option>
                        </select> -->
                        <Select
                            v-model="riskPriorityShow.priority"
                            :options="dbPriority"
                            optionLabel="key"
                            optionValue="value"
                            placeholder="Priority"
                            class="custom-multiselect w-full"
                        />
                    </div>

                    <div class="text-red-500" v-if="v$.riskPriorityShow.priority.$error">
                        <div v-if="v$.riskPriorityShow.priority.required.$invalid" class="error-text text-xs">Please change priority</div>
                    </div>
                    <div v-if="this.riskPriorityShow.priority !== this.priorityDummy.priority">
                        <div class="row flex flex-row w-full">
                            <div class="w-full upperspacing">
                                <label for="Risk" class="controllabel">Justification</label> 
                                <textarea
                                    class="inputboxstyling"
                                    placeholder="Justification"
                                    v-model.trim="riskPriorityShow.justification"
                                    :class="{
                                        'is-invalid': v$.riskPriorityShow.justification.$error
                                    }"
                                />
                            </div>
                        </div>
                        <div class="text-red-500" v-if="v$.riskPriorityShow.justification.$error">
                            <div v-if="v$.riskPriorityShow.justification.required.$invalid" class="error-text text-xs">Justification is required</div>
                        </div>
                    </div>

                </div>
                <div class="border-b border-solid border-lightgrey mx-5"></div>
                <div class="buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5">
                    <button :disabled="clickOnButton" class="btnprimary mr-1.5" :class="JSON.stringify(riskPriorityShow) !== JSON.stringify(priorityDummy) ? 'btnprimary' : 'btndisabled pointer-events-none'" @click="cancelPriorityBtn()">Reset</button>
                    <button :disabled="clickOnButton" @click="addOrUpdatePriority()" :class="JSON.stringify(riskPriorityShow) !== JSON.stringify(priorityDummy) ? 'btnprimary' : 'btndisabled pointer-events-none'">Save</button>
                </div>
            </div>
        </popup>
    </div>
</template>
<style scoped>
.tab-container {
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
  gap: 60px !important; 
}
.tooltipwidth {
    width: 180px !important;
}
.borderRed {
    border: 1px solid red !important;
}
.loader {
    border: 16px solid #f3f3f3;
    border-top: 16px solid var(--color-primary);
    border-radius: 50%;
    width: 30px;
    height: 30px;
    animation: spin 1s linear infinite;
    margin: 20px auto;
}
.midHead {
    width: 160px !important;
}
.widthForSelect{
    width : 100px !important;
}
.inputboxstylingForSelect .optionColors{
   color : #4D4D4D !important;
}
@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
.nonEmptyTable tr:last-child {
    border-bottom: 1px solid #e9e9e9;
}
.anime-left {
    animation-name: moveLeft;
    animation-duration: 1s;
    animation-iteration-count: 1;
    animation-fill-mode: backwards;
}
@keyframes moveLeft {
    0% {
        opacity: 1;
        transform: translateX(100vw);
    }
    100% {
        transform: translateX(0);
    }
}
.anime-right {
    animation-name: moveRight;
    animation-duration: 1s;
    animation-iteration-count: 1;
    animation-fill-mode: backwards;
}
@keyframes moveRight {
    0% {
        opacity: 1;
        transform: translateX(-100vw);
    }
    100% {
        transform: translateX(0);
    }
}
/* .progressbarSI {
    border: 2px solid #e9e9e9;
    background: #e9e9e9;
    position: relative;
    top: -8px;
    border-radius: 2px;
}
.progress {
    background: #152a43;
} */
.setBox {
    width: initial;
}

.box {
    border: 2px solid red;
}
.adjust {
    flex-shrink: 0;
}
.button-adjust {
    position: relative;
    top: -30px;
    z-index: 1;
    cursor: pointer;
}
.borderBottom {
    position: relative;
    z-index: 2;
    cursor: pointer;
}
.businesssPopup label {
    font-size: 16px;
}
.z-index {
    z-index: 100;
}
.accept {
    width: 100px;
}
.ellipsis-container {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.veryLowOpacity{
    background-color: rgba(0, 176, 80, 0.2);
}
.LowOpacity{
    background-color: rgba(146, 208, 80, 0.2);
}
.ModerateOpacity{
    background-color: rgba(255, 153, 0, 0.2);
}
.HighOpacity{
    background-color: rgba(255, 0, 0, 0.2);
}
.veryHighOpacity{
    background-color: rgba(192, 0, 0, 0.2);
}
.tabStructure {
  height: calc(100vh - 163px);
}
.tabControlMapping {
  height: calc(100vh - 235px); 
}
.inputboxstylingForSelect .optionColors{
   color : #4D4D4D !important;
}
</style>
<script lang="ts">
import { defineComponent } from 'vue';
import _ from 'lodash';
import popup from '@/components/popup.vue';
import useVuelidate from '@vuelidate/core';
import { required, helpers, requiredIf } from '@vuelidate/validators';
import { emitter, toast } from '@/main';
import moment from 'moment';
import store from '@/store';
import { mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';
import dropdown from '@/components/dropdown.vue';
import breadCrumb from '@/components/breadCrumb.vue';
import ToggleSwitch from 'primevue/toggleswitch';

import pagination from '@/components/pagination.vue';
const alphabet = helpers.regex(/^[a-zA-Z]+$/);
import newTable from '@/components/newTable.vue';
import toolTip from '@/components/toolTip.vue';
import Select from 'primevue/select';
import AutoComplete from 'primevue/autocomplete';
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import dotsLoader from '@/components/dotsLoader.vue';

export default defineComponent({
    data(): any {
        return {
            v$: useVuelidate(),
            suggestionSwitch: '',
            residualData:{},
            //Tooltip
            pop: false,
            isMonitored:false,
            xPos: '',
            yPos: '',
            routesArray: [],
            //Pagination
            paginationObj: [],
            pageSize: 20,
            currentPage: 1,
            pageBoxes: 3,
            pageIndexStart: [],
            leftBox: 'left',
            rightBox: 'right',
            pageIndexEnd: [],
            totalPages: '',
            pagesArray: [],
            clickOnButton: false,
            start: '',
            end: '',
            //Sort
            openRiskInformation:false,
            currentSort: 'name',
            currentSortDir: 'asc',
            className: '',
            classSort: '',
            dummyresidualData:{},
            //Carousel
            selectedTabObj: { displayName: 'Risks', name: 'Risk', id: 0 },
            carouselHead: [
                { displayName: 'Risks', name: 'Risk', id: 0 },
                { displayName: 'Properties', name: 'Properties', id: 2 },
                { displayName: 'Risk Discovery', name: 'Risk Discovery', id: 3 },

                { displayName: 'Information', name: 'Information', id: 1 },

            ],
            sideButton: false,
            //BreadCrumb
            index: 0,
            navIndexNums: [],

            //Permissions
            disabled: false,
            // permissions: [],
            tipIndex: '',
            tipColumn: '',
            //Risk Assesment
            selectAll: false,
            checkedItems: [],
            systemAssesmentList: [],
            rootRiskList: [],
            selectedIndex: null,
            rowData: [],
            discovery: false,
            insertedIds: [],
            newInformationObj: [],
            allSystems: [],
            informationList: [],
            userOptions: [],
            searchValue: '',
            addInfoMethod: {},
            addInfo: false,
            infoId: [],
            orgUsersList: [],
            optionsUserArray: [],
            applyPopup: false,
            applyObj: {
                systems: [],
                comments: ''
            },
            showAddRiskPopup: false,
            thisScreen: '',
            mainSystem: [],
            mappedSystemsOptions: [],
            providerList: ['AWS', 'Microsoft Azure', 'Google Cloud', 'DigitalOcean', 'IBM', 'Rackspace', 'Oracle', 'Red Hat', 'Alibaba'],
            information: {
                id: '',
                information: '',
                informationCategory: '',
                informationOwner: '',
                confidentiality: '',
                integrity: '',
                availability: '',
                securityCategory: '',
                // systems: []
                classification: ''
            },
            activeValues: [
				{
					id: 1,
					value: 'Active'
				},
				{
					id: 2,
					value: 'Inactive'
				}
			],
            addInformationObj: [],
            infoTableRow: [],
            systems: [],
            riskList: [],
            showFilters: false,
            filterOptionOpen: true,
            hostingProviderData:[],
            riskId: [],
            dummyList: [],
            assesmentlist: [],
            tenantsSelect: [],

            selectedRowIndex: -1,
            showBlock: false,
            showDropdown: false,
            addingRisk: false,
            riskListData: [],

            filterDummy: {
                severity: '',
                overallImpact: '',
                likelihood: '',
                statusCode: ''
            },

            openRiskPopup: false,
            showInformationPopup: false,
            selectedCategory: [],
            categories: [],
            likelihoodMapping: [],

            optionsList: [],
            filteredOptionsList: [],
            groupByInfos: '',
            editPop: false,
            risk: [],
            managedByOptions: [],
            businessEntityList: [],
            tenants: [],
            riskThreatData: {
                risk: '',
                threatCategory: '',
                threatSource: '',
                threatEvent: '',
                vulnerability: '',
                business: '',
                operations: '',
                legal: '',
                financial: '',
                likelihood: '',
                riskCategory: '',
                overallImpact: '',
                severity: '',
                riskOwner: '',
                riskAssessment:''
            },

            //Systems
            system: {
                systemName: '',
                ownedBy: '',
                description: '',
                managedBy: '',
                owner: '',
                hostingType: '',
                hostingProvider: '',
                publicFacing: '',
                add: '',
                country: '',
                state: '',
                city: ''
            },
            addCIAInfo: true,
            dummySystems: {},
            dynamicPagination: '',
            tasksData: [],
            mainRisk: null,
            objToBeModified: {},
            presentTip: '',

            informationHeaders: ['entityId', '_id', 'category', 'information', 'securityCategory'],
            riskHeaders: ['severity', 'risk', 'riskOwnerName', 'createdAt', 'updatedAt','treatmentType', 'statusCode', 'priority', 'History', 'actionButton'],

            countriesList: [],
            statesList: [],
            citiesList: [],
            stateInfoList: [],

            countriesStatesCities: [
                {
                    CountryName: 'India',
                    States: [
                        {
                            StateName: 'Maharashtra',
                            Cities: ['Pune', 'Nagpur', 'Mumbai']
                        },
                        {
                            StateName: 'Kerala',
                            Cities: ['Kochi', 'Munnar']
                        },
                        {
                            StateName: 'Telangana',
                            Cities: ['Hyderabad', 'Nizamabad', 'Warangal']
                        },
                        {
                            StateName: 'Andhra Pradesh',
                            Cities: ['Vijayawada', 'Vizag', 'Rajamundry']
                        }
                    ]
                },
                {
                    CountryName: 'Australia',
                    States: [
                        {
                            StateName: 'Aukland',
                            Cities: ['GlenField', 'Henderson', 'MilFord']
                        },
                        {
                            StateName: 'Melbourne',
                            Cities: ['Melbourne', 'South Oakleigh']
                        }
                    ]
                }
            ],
            cloud: ['AWS', 'Microsoft Azure', 'Google Cloud', 'DigitalOcean', 'IBM', 'Rackspace', 'Oracle', 'Red Hat', 'Alibaba'],
            hostingTypeObj: [
                {
                    id: 1,
                    value: 'On-premise'
                },
                {
                    id: 2,
                    value: 'Data center'
                },
                {
                    id: 3,
                    value: 'Cloud'
                }
            ],
            yesNo: [
                {
                    id: 1,
                    value: 'Yes'
                },
                {
                    id: 2,
                    value: 'No'
                }
            ],
            riskCategoryList: [],
            threatCategoryList: [],
            threatSourceList: [],
            infoList: [],
            infoCategoryList: [],
            rootRisksList: [],
            showPriorityPopUp: false,
            riskPriorityShow: {},
            priorityDummy: {},
            visibleTabs: [], // Tabs visible on screen
            currentGroupIndex: 0, // Current group index for small screens
            tabsPerGroup: 3, // Number of tabs per group for small screens
            isSmallScreen: false, // Flag for screen size
            canScrollLeft: false, // Whether tabs can scroll left
            canScrollRight: true, // Whether tabs can scroll right
            totalGroups: 0, // Total number of groups for small screens
            toolTipActive : false,
            toolTipText : '',
            dataLoading:true,
			displayErrorMessageOfRisk : false,
			displayErrorMessageOfThreat : false,
			displayErrorMessageOfVulnerability : false,
            displayErrorMessageOfAssessment:false,
            searchRiskCategoryList:[],
            searchThreatCategoryList:[],
            searchThreatSourceList :[]
        };
    },
    components: {
        popup,
        breadCrumb,
        Multiselect,
        pagination,
        newTable,
        toolTip,
        Select,
        AutoComplete,
        Tabs,
        TabList,
        Tab,
        TabPanels,
        TabPanel,
        dotsLoader,
        ToggleSwitch
    },
    validations() {
        return {
            system: {
                systemName: { required },
                ownedBy: { required },
                description: { required },
                managedBy: { required },
                hostingType: { required },
                owner: { required },
                publicFacing: { required },
                add: {
                    required: requiredIf(() => {
                        return this.system.publicFacing == '1';
                    })
                },
                city: { required, alphabet },
                state: { required, alphabet },
                country: { required, alphabet },
                hostingProvider: { required }
            },
            information: {
                informationCategory: { required },
                information: { required },
                informationOwner: { required },
                confidentiality: { required },
                integrity: { required },
                availability: { required },
                securityCategory: { required },
                classification: { required }
            },
            applyObj:{
                comments:{required}
            },
            riskThreatData: {
                risk: { required },
                threatEvent: { required },
                vulnerability: { required },
                riskAssessment:{required},
                business: { required },
                operations: { required },
                legal: { required },
                financial: { required },
                likelihood: { required },
                riskCategory: { required },
                riskOwner: { required }
            },
            residualData: {
                business: { required },
                operations: { required },
                legal: { required },
                financial: { required },
                likelihood: { required },
            },
            riskPriorityShow: {
                risk: { required },
                priority: {
                    required: requiredIf(() => {
                        return this.priorityDummy.priority === this.riskPriorityShow.priority;
                    })
                },
                justification: { required }
            }
        };
    },
    computed: {
        ...mapGetters({
            userInfo: 'userInfo',
            dbSeverity: 'dbSeverity',
            dbLikelihood: 'dbLikelihood',
            dbBussiness: 'dbBussiness',
            dbOrganization: 'dbOrganization',
            dbOperations: 'dbOperations',
            dbLegal: 'dbLegal',
            dbFinancial: 'dbFinancial',
            dbTechnical: 'dbTechnical',
            dbProcessCriticality: 'dbProcessCriticality',
            dbAvailability: 'dbAvailability',
            dbConfidentiality: 'dbConfidentiality',
            dbIntegrity: 'dbIntegrity',
            dbInformationClassification: 'dbInformationClassification',
            dbSecurityCategory: 'dbSecurityCategory',
            dbPriority: 'dbPriority',
            dbOverAllImpact: 'dbOverAllImpact',
            tenentsInfo:'tenentsInfo'
        }),
        disableStatus: function (): any {
            if (this.selectedIndex == 0) {
                let disableStatusCondition;
                if (this.riskThreatData && !this.addingRisk) {
                    if (JSON.stringify(this.riskThreatData) == JSON.stringify(this.riskObjCopy)) {
                        disableStatusCondition = false;
                    } else {
                        disableStatusCondition = true;
                    }
                } else {
                    let valueArray: any = [];
                    Object.values(this.riskThreatData).forEach((value: any) => {
                        valueArray.push(value);
                    });
                    for (let value of valueArray) {
                        if (value != '') {
                            disableStatusCondition = true;
                        }
                    }
                }
                return disableStatusCondition;
            } else if (this.selectedIndex == 2) {
                let disableStatusCondition;
                if (this.objToBeModified) {
                    if (JSON.stringify(this.objToBeModified) == JSON.stringify(this.dummySystems)) {
                        disableStatusCondition = false;
                    } else {
                        disableStatusCondition = true;
                    }
                }
                return disableStatusCondition;
            } else {
                let output;
                if (this.editPop) {
                    let objCopy = Object.assign({}, this.information);
                    if (JSON.stringify(objCopy) == JSON.stringify(this.dummyObj)) {
                        output = false;
                    } else {
                        output = true;
                    }
                } else {
                    let val: any = [];
                    Object.values(this.information).forEach((value: any) => {
                        val.push(value);
                    });
                    for (let n of val) {
                        if (n != '') {
                            output = true;
                        }
                    }
                }
                return output;
            }
        },
        sortedData: function (): any {
            return [...this.paginationObj]
                .filter((row: any) => {
                    for (const key in this.filterDummy) {
                        const inputValue = this.filterDummy[key];
                        if (inputValue !== '' && row[key]) {
                            if (Number.isInteger(row[key])) {
                                if (row[key] !== Number(inputValue)) {
                                    return false;
                                }
                            } else {
                                if (!row[key].toLowerCase().includes(inputValue.toLowerCase())) {
                                    return false;
                                }
                            }
                        }
                    }
                    return true;
                })
                .sort((a, b) => {
                    let modifier = 1;
                    if (this.currentSortDir === 'desc') modifier = -1;
                    if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
                    if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
                    return 0;
                })
                .filter((row, index) => {
                    this.dynamicPagination = index + 1;
                    let start = (this.currentPage - 1) * this.pageSize;
                    let end = this.currentPage * this.pageSize;
                    if (index >= start && index < end) return true;
                });
        },
        tabHead(): any {
            return this.carouselHead.filter((row: any, index: any) => {
                let start = (this.currentPage - 1) * this.pageSize;
                this.index = 0;
                let end = this.currentPage * this.pageSize;

                if (index >= start && index < end) return true;
            });
        }
    },

    async mounted() {
        this.dataLoading = true;

        this.visibleTabs = [...this.carouselHead];
        // this.selectedIndex = 0;
        // window.addEventListener('resize', this.handleResize);
        // this.handleResize(); // Initial setup
        // this.updateButtonStates(); // Initial update to button states
        await this.getSystems();
        await this.getAllTenants();
        await this.getSystemInformation();
        if (this.userInfo.currentRole == 10210 || this.userInfo.currentRole == 10209) {
            this.carouselHead.pop();
        }
        await this.getAllTasks();
        let savedTabKey: any = sessionStorage.getItem('selectedTab');
		if (savedTabKey) {
            savedTabKey = parseInt(savedTabKey)
		    const savedTab = this.carouselHead.find((tab: any) => tab.id == savedTabKey);
            if (savedTab) {
                await this.toggleTabs(savedTab);
            }else{
                this.selectedTabObj = { displayName: 'Risks', name: 'Risks', id: 0 },
                this.selectedIndex = 0;
                this.navIndexNums = { index: 2, name: 'Properties' };
            }
		}
		else{
			this.selectedTabObj = { displayName: 'Risks', name: 'Risks', id: 0 },
            this.navIndexNums = { index: 2, name: 'Properties' };
			this.selectedIndex = 0;
            await this.toggleTabs(this.selectedTabObj);
		}
        // await this.toggleTabs(0);

        await this.getBusinessEntities();
        await this.getThirdParties();

        await this.getRisksList();
        await this.getRootRiskList();

        this.dataLoading = false;


        let systemId = this.$route.params.id;
        this.routesArray = [
            { name: 'System Risk', routeName: 'systems' },
            { name: this.system.systemName, routeName: 'systemInformation', id: `${systemId}` }
        ];
        this.navIndexNums = { index: 2, name: 'Properties' };

        emitter.off('activiteToolTip');
        emitter.on('activiteToolTip', (data: any) => {
            this.toolTipActive = true;
            this.toolTipText = data.tipText
        });
 
        emitter.off('deActiviteToolTip');
        emitter.on('deActiviteToolTip', (data: any) => {
            this.toolTipActive = false;
            this.toolTipText = ''
        });

        emitter.off('showData123');
        emitter.on('showData123', (isData: any) => {
            let comingId = isData.entityData._id;
            if (this.selectedIndex == 1) {
                let showObj = this.optionsList.find((obj: any) => {
                    return obj._id === comingId;
                });
                this.showEditPopUp(showObj);
            } else {
                let showObj = this.paginationObj.find((obj: any) => {
                    return obj._id === comingId;
                });
                this.showPopupbyRow(showObj);
            }
        });

        emitter.off('changeRouteInSystemInfo');
        emitter.on('changeRouteInSystemInfo', (selectedActionObj: any) => {
            let risk = selectedActionObj.data;
            let route = selectedActionObj.route;
            this.residualData = {...risk};
            this.dummyresidualData={...risk}
            this.changeRoute(risk, route);
        });

        emitter.off('showPriorityPopup');
        emitter.on('showPriorityPopup', (isData: any) => {
            this.showPriorityPopUpAction(isData);
        });

        this.scalesInfo = store.getters.scalesInfo;
        await store.dispatch('getScalesInfo').then(async (res: any) => {
            this.scalesInfo = store.getters.scalesInfo;
            this.likelihoodMapping = this.scalesInfo.filter((scale: any) => {
                return scale.entity == 'Likelihood';
            });
            this.severityMapping = this.scalesInfo.filter((scale: any) => {
                return scale.entity == 'Likelihood';
            });
            this.impactMapping = this.scalesInfo.filter((scale: any) => {
                return scale.entity == 'Impact';
            });
        });
    },
    methods: {
        asyncFind(query:any){
            query=query.query
            this.searchValue = query
			if(query == ''){
				this.userOptions = []
			}else if(query.length > 0){
				this.userOptions = this.optionsUserArray.filter((obj:any)=>{return obj.label.toLowerCase().includes(query.toLowerCase())})
			}
		},
        asyncRiskCategoryDataFind(query:any) {
            query=query.query
            this.searchValue = query
			query = query.trim();
			if (query == '') {
				this.searchRiskCategoryList = [];
			} else {
				this.searchRiskCategoryList = this.riskCategoryList.filter((item:any) => 
					item?.toLowerCase().includes(query.toLowerCase())
				);
				let isNewOption = !this.riskCategoryList.some((item:any) => 
					item?.toLowerCase() === query.toLowerCase()
				);
				if (isNewOption && query !== '') {
					this.searchRiskCategoryList.push(query);
				}
			}
		},
        selectedRiskCategoryOption(opt:any){
            const selected = opt.value;
			let isNewOption = !this.riskCategoryList.some(
               (item: any) => item.id == selected.id
            );
			isNewOption==true ? this.riskCategoryList.push(selected) : ''
		},
        asyncthreatCategoryDataFind(query:any) {
            query=query.query
            this.searchValue = query
			query = query.trim();
			if (query == '') {
				this.searchThreatCategoryList = [];
			} else {
				this.searchThreatCategoryList = this.threatCategoryList.filter((item:any) => 
					item?.toLowerCase().includes(query.toLowerCase())
				);
				let isNewOption = !this.threatCategoryList.some((item:any) => 
					item?.toLowerCase() === query.toLowerCase()
				);
				if (isNewOption && query !== '') {
					this.searchThreatCategoryList.push(query);
				}
			}
		},
        selectedOption(opt:any){
            const selected = opt.value;
			let isNewOption = !this.threatCategoryList.some(
               (item: any) => item.id == selected.id
            );
			isNewOption==true ? this.threatCategoryList.push(selected) : ''
		},
        selectedThreatSourceOption(opt:any){
            const selected = opt.value;
			let isNewOption = !this.threatSourceList.some(
               (item: any) => item.id == selected.id
            );
			isNewOption==true ? this.threatSourceList.push(selected) : ''
		},
		asyncthreatSourceDataFind(query:any) {
            query=query.query
            this.searchValue = query
			query = query.trim();
			if (query == '') {
				this.searchThreatSourceList = [];
			} else {
				this.searchThreatSourceList = this.threatSourceList.filter((item:any) => 
					item?.toLowerCase().includes(query.toLowerCase())
				);
				let isNewOption = !this.threatSourceList.some((item:any) => 
					item?.toLowerCase() === query.toLowerCase()
				);
				if (isNewOption && query !== '') {
					this.searchThreatSourceList.push(query);
				}
			}
		},
        colorStatusBg(value:any){
           if (value == 1) {
            return ["bg-veryLowColor border-solid border border-lightgreen"];
          }
          else if (value == 2) {
            return ["bg-highColor border-solid border border-error"];
          }
        },
        lablesData(labelInfo:any,id:number){
            if(id==1){
                let v=this.dbBussiness.find((a:any)=>{
                    return labelInfo==a.value
                })
                if(v!=undefined){
                    return v.key
                }
                else{
                    return 'N/A'
                }
            }
            if(id==2){
                let v=this.dbFinancial.find((a:any)=>{
                    return labelInfo==a.value
                })
                if(v!=undefined){
                    return v.key
                }
                else{
                    return 'N/A'
                }
            }
            if(id==3){
                let v=this.dbOperations.find((a:any)=>{
                    return labelInfo==a.value
                })
                if(v!=undefined){
                    return v.key
                }
                else{
                    return 'N/A'
                }
            }
            if(id==4){
                let v=this.dbLegal.find((a:any)=>{
                    return labelInfo==a.value
                })
                if(v!=undefined){
                    return v.key
                }
                else{
                    return 'N/A'
                }
            }
            if(id==5){
                let v=this.dbLikelihood.find((a:any)=>{
                    return labelInfo==a.value
                })
                if(v!=undefined){
                    return v.key
                }
                else{
                    return 'N/A'
                }
            }
            if(id==6){
                let v=this.dbOverAllImpact.find((a:any)=>{
                    return labelInfo==a.value
                })
                if(v!=undefined){
                    return v.key
                }
                else{
                    return 'N/A'
                }
            }
        },
        colorStatusText(value:any){
          if(value==1){
            return ["text-lightgreen font-semibold"];
          }
          else if(value==2){
            return ["text-error font-semibold"];
          }
        },
        getStatusLabel(value:any){
          if(value=='N/A'){
            return ''
          }
          else{
            let a = this.activeValues.find((val:any)=>val.id == value);            
            return a!=undefined?a.value:''
          }
        },
         async calculateOverallImpact(){
            let a1 = this.riskThreatData.business == '' ? 0 : this.riskThreatData.business;
            let a2 = this.riskThreatData.operations == '' ? 0 : this.riskThreatData.operations;
            let a3 = this.riskThreatData.legal == '' ? 0 : this.riskThreatData.legal;
            let a4 = this.riskThreatData.financial == '' ? 0 : this.riskThreatData.financial;

                        // actions performing popup
            let b1 = this.residualData.business == '' ? 0 : this.residualData.business;
            let b2 = this.residualData.operations == '' ? 0 : this.residualData.operations;
            let b3 = this.residualData.legal == '' ? 0 : this.residualData.legal;
            let b4 = this.residualData.financial == '' ? 0 : this.residualData.financial;

            let arr = [a1, a2, a3, a4]
            let residualInfo = [b1,b2,b3,b4];

            let avg =  arr.reduce((p: any, c: any) => p + c, 0) / arr.length;
            let residualAvg =  residualInfo.reduce((p: any, c: any) => p + c, 0) / residualInfo.length;
            this.riskThreatData.overallImpact = Math.max(Math.round(avg), 1);
            this.residualData.overallImpact = Math.max(Math.round(residualAvg), 1);
            if (this.residualData.likelihood) {
                let severityScore = this.residualData.overallImpact * this.residualData.likelihood;
                this.residualData.severity = this.riskSeverity(severityScore);
            }
        },
        openRisk(row:any) {
            this.riskThreatData = { ...row }; 
            this.openRiskInformation = true;
        },
        changeInfoCategory(id: any) {
            this.infoList = [];
            this.information.confidentiality = '';
            this.information.availability = '';
            this.information.integrity = '';
            this.information.securityCategory = '';
            this.information.information = '';
            
            this.optionsList.map((obj: any) => {
                if (obj.informationCategory === id) {
                    const isInTable = this.infoTableRow.some((row: any) => row.information === obj.information);
                    if (!isInTable) {
                        this.infoList.push(obj.information);
                    }
                }
            });
        },
        changeInformation(name: any) {
            if (name == '' || name == null || name == undefined) {
                this.addCIAInfo = true;
                this.information.confidentiality = '';
                this.information.availability = '';
                this.information.integrity = '';
                this.information.informationOwner = '';
                this.information.id = '';
            } else {
                this.addCIAInfo = false;
                let findObj: any = this.optionsList.find((obj: any) => {
                    return obj.information == name;
                });
                this.information.confidentiality = findObj.confidentiality;
                this.information.availability = findObj.availability;
                this.information.integrity = findObj.integrity;
                this.information.classification = findObj.classification
                this.information.informationOwner = this.optionsUserArray.find((obj:any)=>{return obj.value == findObj.informationOwner});
                this.information.id = findObj._id;
                this.getMaxIdValue();
            }
        },
        restrictCharacters(code: any){
            if(code === 'Threat'){
                if(this.riskThreatData.threatEvent.length > 1000){
                this.displayErrorMessageOfThreat = true;
                }else if(this.riskThreatData.threatEvent.length < 1000 || this.riskThreatData.threatEvent.length == 1000){
                    this.displayErrorMessageOfThreat = false;
                }
            } else if(code === 'Risk'){
                if(this.riskThreatData.risk.length > 300){
                    this.displayErrorMessageOfRisk = true;
                }else if(this.riskThreatData.risk.length < 300 || this.riskThreatData.risk.length == 300){
                    this.displayErrorMessageOfRisk = false;
                }
            } else if(code === 'Vulnerability'){
                if(this.riskThreatData.vulnerability.length > 1000){
                    this.displayErrorMessageOfVulnerability = true;
                }else if(this.riskThreatData.vulnerability.length < 1000 || this.riskThreatData.vulnerability.length == 1000){
                    this.displayErrorMessageOfVulnerability = false;
                }
            }else if(code === 'Assessment'){
                if(this.riskThreatData.riskAssessment.length > 1000){
                    this.displayErrorMessageOfAssessment = true;
                }else if(this.riskThreatData.riskAssessment.length < 1000 || this.riskThreatData.riskAssessment.length == 1000){
                    this.displayErrorMessageOfAssessment = false;
                }
            }
            
        },
        getRiskStateValue(value: any) {
            let label = this.dbLikelihood.find((l: any) => {
                return l.value == value;
            });
            if (label == undefined) {
                return '';
            } else {
                return label.key;
            }
        },
        getOverallValue(value:any){
            let label = this.dbOverAllImpact.find((l: any) => {
                return l.value == value;
            });
            if (label == undefined) {
                return '';
            } else {
                return label.key;
            }
        },
        paginationUpdations(currentPage: any, pageSize: any) {
            this.currentPage = currentPage;
            this.pageSize = pageSize;
        },
        async addOrUpdaterisk(riskData: any) {
            this.v$.riskThreatData.$touch();
            // this.risk.push(riskData);

            if (!this.v$.riskThreatData.$invalid && this.displayErrorMessageOfRisk == false && this.displayErrorMessageOfThreat == false && this.displayErrorMessageOfVulnerability == false  && this.displayErrorMessageOfAssessment== false) {
                this.clickOnButton = true
                if (this.addingRisk == true) {
                    await this.addRiskList();
                } else {
                    let copyOfriskData:any = {...riskData}
                    let oldObj: any = {};
                    let newObj: any = {};
                    Object.keys(copyOfriskData).map((key: any) => {
                        if (copyOfriskData[key] != this.riskObjCopy[key] && key != 'updatedValues') {
                            oldObj[key] = this.riskObjCopy[key];
                            newObj[key] = copyOfriskData[key];
                        }
                    });
                    copyOfriskData.updatedValues = { oldRisk: [], newRisk: [] };
                    copyOfriskData.updatedValues.oldRisk.push(oldObj);
                    copyOfriskData.updatedValues.newRisk.push(newObj);

                    this.risk.push(copyOfriskData);
                    await this.updateRisk();
                }
            } 
            // else {
            //     toast.error(`error`, {
            //         timeout: 1000,
            //         closeOnClick: true,
            //         closeButton: 'button',
            //         icon: true
            //     });
            // }
            this.risk = [];
        },
        async addRiskList() {
            const finalArray: Record<string, any> = [];
            let copyOfriskThreatData:any = {...this.riskThreatData}
            finalArray.push(copyOfriskThreatData);
            finalArray.map((obj: any) => {
                obj.statusCode = 10401;
                obj.createdAt = new Date();
                obj.createdBy = this.userInfo._id;
                obj.tier = 3;
                obj.systems = [];
                obj.riskOwner = obj.riskOwner.value;
                let systemId: any = this.$route.params.id;
                obj.systems.push(systemId);
            });
            try {
                await this.$http.post(`${process.env.VUE_APP_RISK_API}/api/root/risk/create?org==true`, finalArray).then((result: any) => {
                    let riskId = result.data.insertedIds[0];
                    const payload: Record<string, any> = [];
                    finalArray[0].systems.map((presentSystemId: any) => {
                        let newObj = { systemId: '', riskId: [`${riskId}`], statusCode: 10401,riskOwner:finalArray[0].riskOwner };
                        newObj.systemId = presentSystemId;

                        payload.push(newObj);
                    });
                    this.createRiskTask(payload);
                });
                this.openRiskPopup = false;
            } catch (e) {
                toast.info('error', {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                });
            } finally{
                this.clickOnButton = false
            }
        },
        async createRiskTask(payload: any) {
            try {
                payload.createdAt = new Date();
                payload[0].tier = 3;
                payload[0].createdAt = new Date();
                payload[0].createdBy = this.userInfo._id;
                await this.$http.post(`${process.env.VUE_APP_RISK_API}/api/org/create/risks`, payload).then((result: any) => {
                    this.systemAssesmentList = result.data;
                    toast.info('created', {
                        timeout: 1000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                    });
                });
                this.openRiskPopup = false;
                this.v$.$reset();
                this.addingRisk = false;
                await this.getOrgSystemRisks();
            } catch (e) {
                toast.error(`error`, {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                });
            }
        },
        async updateRisk() {
            let copyOfrisk = [...this.risk]
            try {
                let riskId = copyOfrisk[0]._id;
                delete copyOfrisk[0]._id;
                delete copyOfrisk[0].overallImpact;
                delete copyOfrisk[0].severity;
                delete copyOfrisk[0].treatmentType;
                copyOfrisk[0].riskOwner = copyOfrisk[0].riskOwner?.value;
                copyOfrisk[0].updatedAt = new Date();
                copyOfrisk[0].updatedBy = this.userInfo._id;
                await this.$http.post(`${process.env.VUE_APP_RISK_API}/api/root/risk/${riskId}/update?org==true`, copyOfrisk[0]).then((result: any) => {
                    toast.info(`Updated succesfully`, {
                        closeOnClick: true,
                        closeButton: 'button'
                    });
                });
                this.openRiskPopup = false;
                this.showPriorityPopUp = false;
            } catch (e) {
                toast.error('error', {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                });
            } finally {
                this.clickOnButton = false
            }
            await this.getOrgSystemRisks();
        },
        showPopupbyRow(obj: any) {
            this.openRiskPopup = true;
            this.riskThreatData = { ...obj };
            this.riskObjCopy = { ...obj };
            this.addingRisk = false;
        },
        doFalse() {
            emitter.emit('deActiviteToolTip')
        },
        addRiskForSystem() {
            this.v$.$reset();
            this.openRiskPopup = true;
            this.addingRisk = true;
            this.riskThreatData = { risk: '', threatCategory: '', threatSource: '', threatEvent: '', vulnerability: '', business: '', operations: '', legal: '', financial: '', likelihood: '', riskCategory: '',overallImpact:'' };
        },
        changeRoute(risk: any, route: any) {
            this.mainRisk = risk;
            this.v$.$reset();
            if (route == '/riskAcceptance' && Object.keys(this.mainRisk).includes('riskOwner')) {
                this.thisScreen = 'Acceptance';                
                if (this.mainRisk.statusCode == 10403 || this.mainRisk.statusCode==10402||this.mainRisk.statusCode==10404|| this.mainRisk.statusCode==10425) {
                    toast.error(`Cannot Accept the Risk in this Status`, {
                        timeout: 1000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                    });
                } else {
                    if (Object.keys(this.mainRisk).includes('tasks')) {
                        // previous logic checking for approvals tasks status not required now
                        // let conditionForAccept = this.mainRisk.tasks.every((taskId: any) => {
                        //     let a = this.tasksData.find((task: any) => {
                        //         return task._id == taskId;
                        //     });
                        //     return a.statusCode == 10403 || a.statusCode == 10410;
                        // });
                        // if (conditionForAccept) {
                            let systemObj = { value: this.$route.params.id, label: this.system.systemName };
                            this.applyPopup = true;
                            this.mappedSystemsOptions.push(systemObj);
                            this.mainSystem.push(systemObj.value);
                            this.applyObj.systems = [...this.mainSystem];
                        // } else {
                            // toast.error(`Tasks in Pending for this Risk`, {
                            //     timeout: 5000,
                            //     closeOnClick: true,
                            //     closeButton: 'button',
                            //     icon: true
                            // });
                        // }
                    } else {
                        let systemObj = { value: this.$route.params.id, label: this.system.systemName };
                        this.applyPopup = true;
                        this.mappedSystemsOptions.push(systemObj);
                        this.mainSystem.push(systemObj.value);
                        this.applyObj.systems = [...this.mainSystem];
                    }
                }
            } else if (route == '/mitigateRisk' && Object.keys(this.mainRisk).includes('riskOwner')) {
                if (this.mainRisk.statusCode == 10406) {
                    this.thisScreen = 'Mitigate';
                    let systemObj = { value: this.$route.params.id, label: this.system.systemName };
                    const mitigateSystems = [];
                    mitigateSystems.push(systemObj.value);
                    localStorage.setItem(this.mainRisk.mappedRisk, JSON.stringify(mitigateSystems));
                    this.$router.push({ name: 'systemsControlsMapWithId', params: { riskId: this.mainRisk.mappedRisk, type: 'system', id: this.mainRisk.systemId }, query: { systems: true } });
                }else if(this.mainRisk.statusCode==10404|| this.mainRisk.statusCode==10425 ||this.mainRisk.statusCode==10402 || this.mainRisk.statusCode==10403 || this.mainRisk.statusCode ==10424 || this.mainRisk.statusCode == 10419){
                        toast.error(`Cannot Mitigate the Risk in this Status`, {
                            timeout: 5000,
                            closeOnClick: true,
                            closeButton: 'button',
                            icon: true
                        });
                    } else if (Object.keys(this.mainRisk).includes('tasks')) {
                    let conditionForMitigate = this.mainRisk.tasks.every((taskId: any) => {
                        let a = this.tasksData.find((task: any) => {
                            return task._id == taskId;
                        });
                        return a.statusCode == 10403 || a.statusCode == 10410;
                    });
                    if (this.mainRisk.statusCode != 10402 && this.mainRisk.statusCode != 10406 && conditionForMitigate) {
                        this.thisScreen = 'Mitigate';
                        let systemObj = { value: this.$route.params.id, label: this.system.systemName };
                        const mitigateSystems = [];
                        mitigateSystems.push(systemObj.value);
                        if (this.mainRisk.statusCode == 10405 || this.mainRisk.statusCode == 10403|| this.mainRisk.statusCode==10425) {
                            toast.error(`Cannot Mitigate the Risk in Mitigate Status`, {
                                timeout: 5000,
                                closeOnClick: true,
                                closeButton: 'button',
                                icon: true
                            });
                        } else {
                            localStorage.setItem(this.mainRisk.mappedRisk, JSON.stringify(mitigateSystems));
                            this.$router.push({ name: 'systemsControlsMapWithId', params: { riskId: this.mainRisk.mappedRisk, type: 'system', id: this.mainRisk.systemId }, query: { systems: true } });
                        }
                    } else {
                        toast.error(`Tasks In pending for this Risk`, {
                            timeout: 5000,
                            closeOnClick: true,
                            closeButton: 'button',
                            icon: true
                        });
                    }
                } else {
                    this.thisScreen = 'Mitigate';
                    let systemObj = { value: this.$route.params.id, label: this.system.systemName };
                    const mitigateSystems = [];
                    mitigateSystems.push(systemObj.value);
                    localStorage.setItem(this.mainRisk.mappedRisk, JSON.stringify(mitigateSystems));
                    this.$router.push({ name: 'systemsControlsMapWithId', params: { riskId: this.mainRisk.mappedRisk, type: 'system', id: this.mainRisk.systemId }, query: { systems: true } });
                }
            } else if (route == '/transfer' && Object.keys(this.mainRisk).includes('riskOwner')) {
                this.thisScreen = 'Transfer';
                if (this.mainRisk.statusCode == 10403 || this.mainRisk.statusCode == 10402||this.mainRisk.statusCode==10404|| this.mainRisk.statusCode==10425) {
                    toast.error(`Cannot Transfer the Risk in this Status`, {
                        timeout: 1000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                    });
                } else {
                    if (Object.keys(this.mainRisk).includes('tasks')) {
                        // let conditionForTransfer = this.mainRisk.tasks.every((taskId: any) => {
                        //     let a = this.tasksData.find((task: any) => {
                        //         return task._id == taskId;
                        //     });
                        //     return a.statusCode == 10403 || a.statusCode == 10410;
                        // });
                        // if (conditionForTransfer) {
                            let systemObj = { value: this.$route.params.id, label: this.system.systemName };
                            this.applyPopup = true;
                            this.mappedSystemsOptions.push(systemObj);
                            this.mainSystem.push(systemObj.value);
                            this.applyObj.systems = [...this.mainSystem];
                        // } else {
                        //     toast.error(`Tasks in Pending for this Risk`, {
                        //         timeout: 5000,
                        //         closeOnClick: true,
                        //         closeButton: 'button',
                        //         icon: true
                        //     });
                        // }
                    } else {
                        let systemObj = { value: this.$route.params.id, label: this.system.systemName };
                        this.applyPopup = true;
                        this.mappedSystemsOptions.push(systemObj);
                        this.mainSystem.push(systemObj.value);
                        this.applyObj.systems = [...this.mainSystem];
                    }
                }
            } else if (route == '/reset' && Object.keys(this.mainRisk).includes('riskOwner')) {
                this.thisScreen = 'reset';
                if (this.mainRisk.statusCode == 10401 || this.mainRisk.statusCode == 10402 ||this.mainRisk.statusCode ==10404|| this.mainRisk.statusCode==10425) {
                    toast.error(`Cannot Reset the Risk in this Status`, {
                        timeout: 5000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                    });
                } else {
                    if (Object.keys(this.mainRisk).includes('tasks')) {
                    // previous logic checking for approvals tasks status not required now
                        // let conditionForReset = this.mainRisk.tasks.every((taskId: any) => {
                        //     console.log('tasksData',this.tasksData,taskId);
                            
                        //     let a = this.tasksData.find((task: any) => {
                        //         return task._id == taskId;
                        //     });
                        //     console.log('12345',a);
                            
                        //     return a.statusCode == 10403 || a.statusCode == 10410;
                        // });
                        // if (conditionForReset) {
                            let systemObj = { value: this.$route.params.id, label: this.system.systemName };
                            this.applyPopup = true;
                            this.mappedSystemsOptions.push(systemObj);
                            this.mainSystem.push(systemObj.value);
                            this.applyObj.systems = [...this.mainSystem];
                        // } else {
                        //     toast.error(`Tasks in Pending for this Risk`, {
                        //         timeout: 5000,
                        //         closeOnClick: true,
                        //         closeButton: 'button',
                        //         icon: true
                        //     });
                        // }
                    } else {
                        let systemObj = { value: this.$route.params.id, label: this.system.systemName };
                        this.applyPopup = true;
                        this.mappedSystemsOptions.push(systemObj);
                        this.mainSystem.push(systemObj.value);
                        this.applyObj.systems = [...this.mainSystem];
                    }
                }
            } else if (route == '/avoid' && Object.keys(this.mainRisk).includes('riskOwner')) {
                this.thisScreen = 'Avoid';
                if (this.mainRisk.statusCode == 10403 || this.mainRisk.statusCode == 10402||this.mainRisk.statusCode==10404|| this.mainRisk.statusCode==10425) {
                    toast.error(`Cannot Avoid the Risk in this Status`, {
                        timeout: 1000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                    });
                } else {
                    if (Object.keys(this.mainRisk).includes('tasks')) {
                        // let conditionForAvoid = this.mainRisk.tasks.every((taskId: any) => {
                        //     let a = this.tasksData.find((task: any) => {
                        //         return task._id == taskId;
                        //     });
                        //     return a.statusCode == 10403 || a.statusCode == 10410;
                        // });
                        // if (conditionForAvoid) {
                            let systemObj = { value: this.$route.params.id, label: this.system.systemName };
                            this.applyPopup = true;
                            this.mappedSystemsOptions.push(systemObj);
                            this.mainSystem.push(systemObj.value);
                            this.applyObj.systems = [...this.mainSystem];
                        // } else {
                        //     toast.error(`Tasks in Pending for this Risk`, {
                        //         timeout: 5000,
                        //         closeOnClick: true,
                        //         closeButton: 'button',
                        //         icon: true
                        //     });
                        // }
                    } else {
                        let systemObj = { value: this.$route.params.id, label: this.system.systemName };
                        this.applyPopup = true;
                        this.mappedSystemsOptions.push(systemObj);
                        this.mainSystem.push(systemObj.value);
                        this.applyObj.systems = [...this.mainSystem];
                    }
                }
            }else if (route == '/monitered' && Object.keys(this.mainRisk).includes('riskOwner')) {
                this.thisScreen = 'Monitered';                
                if (this.mainRisk.statusCode == 10403 || this.mainRisk.statusCode == 10402||this.mainRisk.statusCode==10404||this.isMonitored==true) {
                    toast.error(`Cannot Monitered the Risk in this Status`, {
                        timeout: 1000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                    });
                } else {
                    if (Object.keys(this.mainRisk).includes('tasks')) {
                        let systemObj = { value: this.$route.params.id, label: this.system.systemName };
                        this.applyPopup = true;
                        this.mappedSystemsOptions.push(systemObj);
                        this.mainSystem.push(systemObj.value);
                        this.applyObj.systems = [...this.mainSystem];
                    } else {
                        let systemObj = { value: this.$route.params.id, label: this.system.systemName };
                        this.applyPopup = true;
                        this.mappedSystemsOptions.push(systemObj);
                        this.mainSystem.push(systemObj.value);
                        this.applyObj.systems = [...this.mainSystem];
                    }
                }
            }  else if (route == '/deactive') {
                this.thisScreen = 'deactive';
                if (this.mainRisk.statusCode == 10402||this.mainRisk.statusCode==10404|| this.mainRisk.statusCode==10425) {
                    toast.error(`Cannot Invalid the Risk in this Status`, {
                        timeout: 5000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                    });
                }
                else{
                    if (Object.keys(this.mainRisk).includes('tasks')) {
                        // let conditionForDelete = this.mainRisk.tasks.every((taskId: any) => {
                        //     let a = this.tasksData.find((task: any) => {
                        //         return task._id == taskId;
                        //     });
                        //     return a.statusCode == 10403 || a.statusCode == 10410;
                        // });
                        // if (conditionForDelete) {
                            let systemObj = { value: this.$route.params.id, label: this.system.systemName };
                            this.applyPopup = true;
                            this.mappedSystemsOptions.push(systemObj);
                            this.mainSystem.push(systemObj.value);
                            this.applyObj.systems = [...this.mainSystem];
                        // } else {
                        //     toast.error(`Tasks in Pending for this Risk`, {
                        //         timeout: 5000,
                        //         closeOnClick: true,
                        //         closeButton: 'button',
                        //         icon: true
                        //     });
                        // }
                    } else {
                        let systemObj = { value: this.$route.params.id, label: this.system.systemName };
                        this.applyPopup = true;
                        this.mappedSystemsOptions.push(systemObj);
                        this.mainSystem.push(systemObj.value);
                        this.applyObj.systems = [...this.mainSystem];
                    }
                }
            } else if (route == '/clone') {
                
                 if(this.mainRisk.statusCode==10404){
                    toast.error(`Tasks In Invalid for this Risk`, {
                        timeout: 5000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                    });
                }else{
                    let tierType: any;
                if (risk.tier == 1) {
                    tierType = 'organization';
                } else if (risk.tier == 2) {
                    tierType = 'process';
                } else if (risk.tier == 3) {
                    tierType = 'systems';
                }

                this.$router.push({ name: 'cloner', params: { mappedRisk: risk.mappedRisk, riskId: risk._id, type: tierType }, query: { systems: true } });
                }
            }
        },
        colorRiskBg(status: any) {
            if (status == 1) {
                return ['veryLowOpacity'];
            } else if (status == 2) {
                return ['LowOpacity'];
            } else if (status == 3) {
                return ['ModerateOpacity'];
            } else if (status == 4) {
                return ['HighOpacity'];
            } else if (status == 5) {
                return ['veryHighOpacity'];
            }
        },
        colorRiskSeverity(status: any) {
            if (status == 1) {
                return ['font-semibold text-lightgreen'];
            } else if (status == 2) {
                return ['font-semibold text-green'];
            } else if (status == 3) {
                return ['font-semibold text-yellow'];
            } else if (status == 4) {
                return ['font-semibold text-error'];
            } else if (status == 5) {
                return ['font-semibold text-darkred'];
            }
        },
        colorRiskText(status: any) {
            if (status == 1) {
                return ['text-lightgreen', 'flex justify-center px-2.5 py-1 font-semibold border-solid border border-lightgreen'];
            } else if (status == 2) {
                return ['text-green', 'flex justify-center px-2.5 py-1 font-semibold border-solid border border-green'];
            } else if (status == 3) {
                return ['text-yellow', 'flex justify-center px-2.5 py-1 font-semibold border-solid border border-yellow'];
            } else if (status == 4) {
                return ['text-error', 'flex justify-center px-2.5 py-1 font-semibold border-solid border border-error'];
            } else if (status == 5) {
                return ['text-darkred', 'flex justify-center px-2.5 py-1 font-semibold border-solid border border-darkred'];
            }
        },
        colorPropBg(format: any, scaleScore: any) {
            if (format == 'circle') {
                if (scaleScore == 5) {
                    return ['bg-darkred'];
                } else if (scaleScore == 4) {
                    return ['bg-error'];
                } else if (scaleScore == 3) {
                    return ['bg-yellow'];
                } else if (scaleScore == 2) {
                    return ['bg-green'];
                } else if (scaleScore == 1) {
                    return ['bg-lightgreen'];
                }
            } else if (format == 'border') {
                if (scaleScore == 5) {
                    return ['border-darkred border-2'];
                } else if (scaleScore == 4) {
                    return ['border-error border-2'];
                } else if (scaleScore == 3) {
                    return ['border-yellow border-2'];
                } else if (scaleScore == 2) {
                    return ['border-green border-2'];
                } else if (scaleScore == 1) {
                    return ['border-lightgreen border-2'];
                }
            }
        },
        getMaxIdValue() {
            this.information.securityCategory = Math.max(this.information.confidentiality, this.information.availability, this.information.integrity);
        },
        selectAllOptions(e: any) {
            this.checkedItems = [];
            this.openRiskInformation=false;
            const checked = e.target.checked;
            if (checked) {
                this.riskId = this.checkedItems;
                for (let obj of this.systemAssesmentList) {
                    this.checkedItems.push(obj._id);
                    this.objLen = this.checkedItems.length;
                }
            } else {
                this.checkedItems = [];
            }
        },
        changeInfo(risk: any, e: any) {
            this.openRiskInformation=false
            this.riskId = this.checkedItems;
            if (this.checkedItems.length === this.systemAssesmentList.length) {
                this.selectAll = true;
            } else {
                this.selectAll = false;
            }
        },
        riskSeverity(value: number) {
            if (value <= 3) {
                return 1;
            } else if (value > 3 && value <= 8) {
                return 2;
            } else if (value > 8 && value <= 12) {
                return 3;
            } else if (value > 12 && value <= 16) {
                return 4;
            } else if (value > 16 && value <= 25) {
                return 5;
            }
        },
        average(arr: any) {
            return arr.reduce((p: any, c: any) => p + c, 0) / arr.length;
        },
        showEditPopUp(obj: any) {
            this.information = {...obj};
            this.information.informationOwner = this.optionsUserArray.find((value: any)=>{return value.value == obj.informationOwner});
            this.addInfo = false;
            this.dummyObj = { ...this.information };
            this.showInformationPopup = true;
        },
        async addInformationToObject() {
            this.v$.information.$touch();
            if (!this.v$.information.$invalid) {
                let obj = { ...this.information };
                this.addInformationObj.push(obj);
                this.infoList = [];
                Object.keys(this.information).forEach((prop) => {
                    Array.isArray(this.information[prop]) ? (this.information[prop] = []) : (this.information[prop] = '');
                });

                this.selectedCategory = [];
                this.addCIAInfo = true;
                this.v$.$reset();
            } 
            // else {
            //     toast.error(`error`, {
            //         timeout: 1000,
            //         closeOnClick: true,
            //         closeButton: 'button',
            //         icon: true
            //     });
            // }
        },
        async getSystems() {
            let entityId = '20005';
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/getall/${entityId}`).then((result: any) => {
                this.allSystems = result.data.map((sys: any) => {
                    return { value: sys._id, label: sys.systemName };
                });
            });
        },
        async getClientSystemRisks() {
            this.risksList = [];
            this.rowData = [];
            let id = this.$route.params.id;
            await this.$http.get(`${process.env.VUE_APP_RISK_API}/api/org/system/${id}/get/risks`).then((result: any) => {
                this.rowData = result.data
                // .filter((obj: any) => {
                //     return obj.statusCode != 10404;
                // });
                this.rowData.forEach((risk: any) => {
                    this.openList = risk;
                    let condition1 = Object.keys(risk).includes('residual') && risk['residual'].length > 0;
                    let averageImpact;
                    let impact;
                    let severity;

                    if (condition1 == true) {
                        let lengthOfArray = risk['residual'].length;
                        let indexObj = risk['residual'][lengthOfArray - 1];

                        if (indexObj.isActive == true) {
                            averageImpact = this.average([indexObj['business'], indexObj['operations'], indexObj['legal'], indexObj['financial']]);
                            impact = Math.round(averageImpact);
                            severity = this.riskSeverity(impact * indexObj['likelihood']);

                            risk.business = indexObj['business'];
                            risk.operations = indexObj['operations'];
                            risk.legal = indexObj['legal'];
                            risk.financial = indexObj['financial'];
                            risk.likelihood = indexObj['likelihood'];
                        } else {
                            averageImpact = this.average([ this.openList['business'], this.openList['operations'], this.openList['legal'], this.openList['financial']]);
                            impact = Math.round(averageImpact);
                            severity = this.riskSeverity(impact * this.openList['likelihood']);
                        }
                    } else if (condition1 == false) {
                        averageImpact = this.average([ this.openList['business'], this.openList['operations'], this.openList['legal'], this.openList['financial']]);
                        impact = Math.round(averageImpact);
                        severity = this.riskSeverity(impact * this.openList['likelihood']);
                    }
                    risk.overallImpact = impact;
                    risk.severity = severity;

                    if (!Object.keys(risk).includes('updatedAt') && risk.updatedAt != '') {
                        risk.updatedAt = '';
                    }

                    risk.entityId = 20006;
                    
                    risk.riskOwner = this.optionsUserArray.find((value: any)=>{return value.value == risk.riskOwner});
                    risk.riskOwnerName = risk.riskOwner != undefined ?  risk.riskOwner.label:'N/A'
                    this.risksList.push(risk);
                });
            });
            // this.$store.dispatch('updateDotsLoading', false);
        },
        async saveInformation() {
            this.showInformationPopup = false;
            var systemId = this.$route.params.id;
            let payload: any = [];

            this.addInformationObj.map((obj: any) => {
                payload.push(obj.id);
            });

            await this.$http.post(`${process.env.VUE_APP_RISK_API}/api/org/system/${systemId}/add/information`, payload).then(async (result: any) => {
                this.addInformationObj = [];
                let infoTabObj = { displayName: 'Information', name: 'Information', id: 1 };
                await this.toggleTabs(infoTabObj);

                toast.info('Info Added', {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                });
            });
        },
        onInfoDelete(index: any): any {
            this.addInformationObj.splice(index, 1);
            toast.error('Inormation Deleted', {
                timeout: 1000,
                closeOnClick: true,
                closeButton: 'button',
                icon: true
            });
        },
        onResetbtn() {
            this.addInformationObj = [];
            this.addCIAInfo = true;
        },
        onCancelRiskData() {
            if (this.addingRisk) {
                this.riskThreatData = { risk: '', threatCategory: '', threatSource: '', threatEvent: '', vulnerability: '', organization: '', business: '', operations: '', technical: '', legal: '', financial: '', likelihood: '', riskCategory: '' };
                this.displayErrorMessageOfRisk = false
                this.displayErrorMessageOfThreat = false
                this.displayErrorMessageOfVulnerability = false
                this.displayErrorMessageOfAssessment=false
                this.v$.$reset();
            } else {
                this.riskThreatData = { ...this.riskObjCopy };
                this.displayErrorMessageOfRisk = false
                this.displayErrorMessageOfThreat = false
                this.displayErrorMessageOfVulnerability = false
                this.displayErrorMessageOfAssessment=false
            }
        },
        async updateInformation(item: any, itemId: any) {
            try {
                let informationId = item._id;

                delete item._id;
                item.updatedAt = new Date();
                await this.$http.post(`${process.env.VUE_APP_ORG_API}/api/root/information/${informationId}/update?org==true`, item).then((result: any) => {
                    toast.info(`Uploaded succesfully`, {
                        closeOnClick: true,
                        closeButton: 'button'
                    });
                });
                const payload: Record<string, any> = [];

                item.systems.forEach((itemSystem: any) => {
                    this.allSystems.forEach((sys: any) => {
                        let systemId = sys.value;
                        if (systemId === itemSystem) {
                            let systemValue = {
                                systemId: systemId,
                                information: [informationId]
                            };
                            payload.push(systemValue);
                        }
                    });
                });
                await this.updateMapping(payload);
            } catch (e) {
                toast.error('error', {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                });
            }
            this.infoTableRow = [];
            this.showInformationPopup = false;
        },
        async addInformation() {
            var systemId = this.$route.params.id;

            if ((!this.information._id && !this.addInfoMethod._id) || this.information.informationOwner != this.addInfoMethod.informationOwner) {
                this.informationList = [];
                this.newInformationObj = {
                    informationCategory: this.information.informationCategory,
                    information: this.information.information,
                    informationOwner: this.information.informationOwner,
                    confidentiality: this.information.confidentiality,
                    integrity: this.information.integrity,
                    availability: this.information.availability,
                    securityCategory: this.information.securityCategory,
                    systems: [systemId]
                };
                this.addInformationObj.push(this.newInformationObj);
            } else {
                let addInfooooo = [];
                addInfooooo = { _id: this.addInfoMethod._id, ...this.information };
                this.addInformationObj.push(addInfooooo);
            }
            this.selectedCategory = [];
            this.v$.$reset();
        },
        async updateMapping(payload: any) {
            try {
                await this.$http.post(`${process.env.VUE_APP_RISK_API}/api/org/mapping/create`, payload).then(async (result: any) => {
                    console.log('updated');
                });
            } catch (e) {
                toast.error('error', {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                });
            }
        },
        onCancelbtn(status: any, type: any) {
            this.addCIAInfo = true;
            if (type == 'system') {
                this.system = { ...this.dummySystems };
                this.objToBeModified = this.system;
            } else {
                this.v$.$reset();
                Object.keys(this.information).forEach((prop) => {
                    Array.isArray(this.information[prop]) ? (this.information[prop] = []) : (this.information[prop] = '');
                });
            }
        },
        onCloseInformation() {
            if(this.addInformationObj && this.addInformationObj.length >0){
                this.addInformationObj = [];
            }
            this.v$.$reset();
            this.showInformationPopup = false;
        },
        showInformation() {
            Object.keys(this.information).forEach((prop) => {
                Array.isArray(this.information[prop]) ? (this.information[prop] = []) : (this.information[prop] = '');
            });
            this.editPop = false;
            this.addInfo = true;
            this.showInformationPopup = true;
        },
        async getRisksDiscoveryForSystem() {
            try {
                await this.$http.get(`${process.env.VUE_APP_RISK_API}/api/org/system/${this.$route.params.id}/assesment`).then((result: any) => {
                    let AssesmentRisks = result.data;
                    this.systemAssesmentList = [];
                    let filteredAssesmentArrayOfRisks: any = [];
                    this.selectAll = false;

                    //Assesment Logic
                    filteredAssesmentArrayOfRisks = AssesmentRisks.filter((assObj: any) => {
                        let findMainObjInRiskList = this.riskList.find((obj: any) => {
                            return obj.mappedRisk == assObj._id;
                        });
                        if (findMainObjInRiskList == undefined) {
                            return true;
                        } else if (findMainObjInRiskList != undefined && findMainObjInRiskList.statusCode == 10404) {
                            return true;
                        } else {
                            return false;
                        }
                    });
                    this.systemAssesmentList = filteredAssesmentArrayOfRisks;

                    //SevCalcoulation for Root data
                    this.systemAssesmentList.forEach((risk: any) => {
                        let averageImpact = Math.round(this.average([ risk.business, risk.operations, risk.legal, risk.financial]));
                        risk.overallImpact = averageImpact;
                        risk.severity = this.riskSeverity(risk.overallImpact * risk.likelihood);
                    });
                    this.paginationObj = [...this.systemAssesmentList];

                    this.dummyList = result.data;
                });
            } catch (e) {
                console.log('error');
            }
        },
        filterOpen() {
            this.showFilters = !this.showFilters;
            if (this.showFilters == true) {
                this.dummyList = this.systemAssesmentList;
            } else {
                this.systemAssesmentList = this.dummyList;
                for (const key in this.filterDummy) {
                    this.filterDummy[key] = '';
                }
            }
            emitter.emit('visible', this.showFilters);
        },
        async getRisksList() {
            await this.$http.get(`${process.env.VUE_APP_RISK_API}/api/org/risks/getall`).then((result: any) => {
                this.riskListData = result.data;
            });
        },
        async getRootRiskList() {
            this.rootRiskList = [];
            this.riskCategoryList = [];
            this.threatCategoryList = [];
            this.threatSourceList = [];

            const result = await this.$http.get(`${process.env.VUE_APP_RISK_API}/api/root/risks/getall?org=true`);
            result.data.map((risk: any) => {
                if(risk.riskCategory){
                    !this.riskCategoryList.includes(risk.riskCategory) ? this.riskCategoryList.push(risk.riskCategory) : '';
                }
                if(risk.threatCategory){
                    !this.threatCategoryList.includes(risk.threatCategory) ? this.threatCategoryList.push(risk.threatCategory) : '';
                }
                if(risk.threatSource){
                    !this.threatSourceList.includes(risk.threatSource) ? this.threatSourceList.push(risk.threatSource) : '';
                }

                if (risk.operations) {
                    let averageImpact = Math.round(this.average([risk.business, risk.operations, risk.legal, risk.financial]));
                    risk.overallImpact = averageImpact;
                    risk.severity = this.riskSeverity(risk.overallImpact * risk.likelihood);
                    this.rootRisksList.push(risk);
                }
            });
        },
        sort: function (s: any) {
            this.className = s;
            if (s === this.currentSort) {
                this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
            }
            this.currentSort = s;
            this.classSort = this.currentSortDir === 'asc' ? 'sort_asc' : 'sort_desc';
        },

        toolTip(risk: any, key: any, columnValue: any, index: any, e: any) {
            if (key == 'severity') {
                 let findVal = this.dbSeverity.find((obj:any)=>{return obj.value == columnValue})

                if(findVal != undefined){
                    this.toolTipText = findVal.key
                }else{
                    this.toolTipText = columnValue
                }

                let obj:any = {
                    tipText : this.toolTipText
                }
                emitter.emit('activiteToolTip',obj)
            } else {
                this.handleTextTooltip(e, key, columnValue, index);
            }
        },
        handleTextTooltip(e: any, key: any, columnValue: any, index: any) {
            const container = e.currentTarget.closest('.table-ellipsis');
            if (container && this.isTextOverflowed(container)) {
                this.toolTipText = columnValue
                let obj:any = {
                    tipText : this.toolTipText
                }

                emitter.emit('activiteToolTip',obj)
            }
        },
        isTextOverflowed(element: any) {
            return element.scrollHeight > element.clientHeight;
        },
        async createAssesmentTask() {
            try {
                let payload = [];
                this.checkedItems = this.checkedItems.filter((x: any) => !this.assesmentlist.includes(x));

                let found = false;
                for (var i = 0; i < this.checkedItems.length; i++) {
                    for (var j = 0; j < this.systemAssesmentList.length; j++) {
                        if (this.systemAssesmentList[j]._id == this.checkedItems[i]) {
                            delete this.systemAssesmentList[j]._id;
                            this.systemAssesmentList[j].riskId = this.riskId;
                            this.systemAssesmentList[j].systemId = this.$route.params.id;
                            this.systemAssesmentList[j].statusCode = 10401;
                            payload.push({
                                systemId: this.systemAssesmentList[j].systemId,
                                riskId: this.systemAssesmentList[j].riskId,
                                statusCode: this.systemAssesmentList[j].statusCode,
                                createdAt: new Date(),
                                createdBy: this.userInfo._id,
                                // updatedStatus: 10401,
                                tier: 3,
                                // riskOwner: this.userInfo._id
                            });
                            found = true;
                            break;
                        }
                        if (found) {
                            break;
                        }
                    }
                }

                await this.$http.post(`${process.env.VUE_APP_RISK_API}/api/org/create/risks`, payload).then((result: any) => {
                    this.checkedItems = [];
                    toast.info('created', {
                        timeout: 1000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                    });
                });
            } catch (e) {
                toast.error(`error`, {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                });
            }
            await this.getOrgSystemRisks();
            await this.getClientSystemRisks();
            await this.getRisksDiscoveryForSystem();
        },

        onCrossbtn() {
            this.openRiskPopup = false;
            this.addingRisk = false;
            this.applyPopup = false;
            this.openRiskInformation=false;
            this.mappedSystemsOptions = [];
            this.mainSystem = [];
            Object.keys(this.applyObj).forEach((prop) => {
                Array.isArray(this.applyObj[prop]) ? (this.applyObj[prop] = []) : (this.applyObj[prop] = '');
            });

            Object.keys(this.riskThreatData).forEach((prop) => {
                Array.isArray(this.riskThreatData[prop]) ? (this.riskThreatData[prop] = []) : (this.riskThreatData[prop] = '');
            });
            this.displayErrorMessageOfRisk = false
            this.displayErrorMessageOfThreat = false
            this.displayErrorMessageOfVulnerability = false
            this.displayErrorMessageOfAssessment=false
            this.v$.$reset();
        },
        cancelAceeptResetBtn() {
            this.v$.$reset();
            this.applyObj.comments = '';
            this.residualData = JSON.parse(JSON.stringify(this.dummyresidualData));
        },
        groupBy(arr: any) {
            return arr.reduce((group: any, product: any) => {
                const { informationCategory } = product;
                group[informationCategory] = group[informationCategory] ?? [];
                group[informationCategory].push(product);
                return group;
            }, {});
        },
        async getInformations() {
            this.infoTableRow = [];
            this.optionsList = [];
            // await this.$http.get(`${process.env.VUE_APP_RISK_API}/api/org/system/${this.$route.params.id}/mappedinformation`).then(async (result: any) => {
            //     this.rowData = result.data;
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/root/information/getall?org=true`).then(async (result: any) => {
                result.data.forEach((info: any) => {
                    this.optionsList.push(info);
                });
            });
            // await this.$http.get(`${process.env.VUE_APP_RISK_API}/api/root/information/getall`).then((result: any) => {

            //     result.data.forEach((info: any) => {
            //         this.optionsList.push(info);
            //     });
            // });
            this.optionsList.forEach((info: any) => {
                !this.infoCategoryList.includes(info.informationCategory) ? this.infoCategoryList.push(info.informationCategory) : '';
                // (!this.infoList.includes(info.information)) ? this.infoList.push(info.information) : '';
            });

            this.groupByInfos = this.groupBy(this.optionsList);

            if (this.optionsList.length > 0) {
                let present = this.optionsList.filter((obj: any) => {
                    if(this.system.informations)
                    {
                        return this.system.informations.includes(obj._id);
                    }
                    else{
                        return false;
                    }
                });

                present.forEach((information: any) => {
                    information.entityId = 20007;
                    this.categories.push(information.informationCategory);
                    this.infoTableRow.push({
                        entityId: information.entityId,
                        _id: information._id,
                        category: information.informationCategory,
                        information: information.information,
                        informationOwner: information.informationOwner,
                        confidentiality: information.confidentiality,
                        integrity: information.integrity,
                        availability: information.availability,
                        securityCategory: information.securityCategory
                    });
                });
            }
            // });
        },
        async getSystemInformation() {
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/system/${this.$route.params.id}/edit`).then((result: any) => {
                this.system = result.data[0];
                
                this.system.ownedBy=this.businessEntityList.find((obj:any)=>{return this.system.ownedBy == obj.value});
                this.system.managedBy=this.managedByOptions.find((obj:any)=>{return this.system.managedBy == obj.value})
                this.system.owner = this.optionsUserArray.find((obj:any)=>{return obj.value == this.system.owner});

                this.objToBeModified = this.system;
                this.dummySystems = { ...result.data[0] };
            });
        },
        async getallUsers() {
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/users/getAll`).then((res: any) => {
                this.orgUsersList = res.data;
                for (var i = 0; i < this.orgUsersList.length; i++) {
                    this.optionsUserArray.push({ label: this.orgUsersList[i].name, value: this.orgUsersList[i]._id });
                }
            });
        },
        async getAllTenants() {
            // await this.$http.get(`${process.env.VUE_APP_AUTH_API}/tenants/getAll`).then((res: any) => {
                this.tenentsInfo.map((org: any) => {
                    const obj = { id: org._id, name: org.organizationName };
                    this.tenants.push(obj);
                    const object = { value: org._id, label: org.organizationName };
                    this.tenantsSelect.push(object);
                });
            // });
        },
        async addOrUpdate(obj: any, entityId: number) {
            this.v$.system.$touch();
            let Id = obj._id;
            if (!this.v$.system.$invalid) {
                if (Id) {
                    delete obj._id;
                    obj.updatedAt = new Date();
                    await this.$http.post(`${process.env.VUE_APP_RISK_API}/api/org/update/${Id}/${entityId}`, obj).then((result: any) => {
                        toast.info('updated', {
                            timeout: 1000,
                            closeOnClick: true,
                            closeButton: 'button',
                            icon: true
                        });
                    });
                }
                this.systemData = [];
                this.getSystemInformation();
            } else {
                toast.error(`cannot save`, {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                });
            }
        },
        async getOrgSystemRisks() {
            this.riskList = [];
            this.rowData = [];
            try{
            await this.$http.get(`${process.env.VUE_APP_RISK_API}/api/org/system/${this.$route.params.id}/risks/get`).then((result: any) => {
                this.rowData = result.data;
                this.rowData.forEach((risk: any) => {
                    this.openList = risk;

                    let condition1 = Object.keys(risk).includes('residual') && risk['residual'].length > 0;
                    let averageImpact;
                    let impact;
                    let severity;

                    if (condition1 == true) {
                        let lengthOfArray = risk['residual'].length;
                        let indexObj = risk['residual'][lengthOfArray - 1];

                        if (indexObj.isActive == true) {
                            averageImpact = this.average([indexObj['business'], indexObj['operations'], indexObj['legal'], indexObj['financial']]);
                            impact = Math.round(averageImpact);
                            severity = this.riskSeverity(impact * indexObj['likelihood']);

                            risk.business = indexObj['business'];
                            risk.operations = indexObj['operations'];
                            risk.legal = indexObj['legal'];
                            risk.financial = indexObj['financial'];
                            risk.likelihood = indexObj['likelihood'];
                        } else {
                            averageImpact = this.average([this.openList['business'], this.openList['operations'], this.openList['legal'], this.openList['financial']]);
                            impact = Math.round(averageImpact);
                            severity = this.riskSeverity(impact * this.openList['likelihood']);
                        }
                    } else if (condition1 == false) {
                        averageImpact = this.average([this.openList['business'], this.openList['operations'], this.openList['legal'], this.openList['financial']]);
                        impact = Math.round(averageImpact);
                        severity = this.riskSeverity(impact * this.openList['likelihood']);
                    }
                    risk.overallImpact = impact;
                    risk.severity = severity;

                    if (!Object.keys(risk).includes('updatedAt') && risk.updatedAt != '') {
                        risk.updatedAt=risk.updatedAt ||'';
                    }
                    risk.riskOwner = this.optionsUserArray.find((value: any)=>{return value.value == risk.riskOwner});
                    risk.riskOwnerName = risk.riskOwner != undefined ? risk.riskOwner.label : 'N/A'
                    risk.treatmentType = risk.action!=undefined?risk.action : 'N/A';
                    this.riskList.push(risk);
                });
            });
            this.paginationObj = [...this.riskList];
}

            catch(error:any) {
        console.error('GET request error:', error.response ? error.response.data : error.message);
    };
          
        },
        async createTaskForAction(applyObj: any, actionCode: any) {
            this.v$.$touch();
            if(!this.v$.applyObj.comments.$invalid){
                this.clickOnButton = true            
                let payload: any = [
                    {
                        systems: applyObj.systems,
                        mappedRisk: this.mainRisk.mappedRisk,
                        createdAt: new Date(),
                        createdBy: this.userInfo._id,
                        action: actionCode
                    }
                ];
                payload[0].comments = applyObj.comments;
                await this.createWorkFlowTask(payload,actionCode);

                Object.keys(this.applyObj).forEach((prop) => {
                    Array.isArray(this.applyObj[prop]) ? (this.applyObj[prop] = []) : (this.applyObj[prop] = '');
                });
                await this.getAllTasks();
                await this.getOrgSystemRisks();

                this.mainSystem = [];
            }
        },
        async createActionForRisk(payload: any) {
            try {
                // await this.$http.post(`${process.env.VUE_APP_RISK_API}/api/org/risk/accept`, payload).then((result: any) => {
                //     // this.systemAssesmentList = result.data;
                //     // toast.info('created', {
                //     //     timeout: 1000,
                //     //     closeOnClick: true,
                //     //     closeButton: 'button',
                //     //     icon: true
                //     // });
                // });
                if(payload[0].action==10403 || payload[0].action == 10419 || payload[0].action == 10424|| payload[0].action == 10425){
                        const actionNameMap: Record<number, string> = {
                        10403: 'accept',
                        // 10404: 'invalid',
                        10424: 'transfer',
                        10419: 'avoid',
                        10425: 'monitered',
                        // 10407: 'reset'
                    };
 
                    const actionName = actionNameMap[payload[0].action];
 
                    if (!actionName) {
                        throw new Error('Invalid action');
                    }
                    if(payload[0].treatmentType==10425){
                            this.isMonitored=true
                        }
                     await this.$http.post(`${process.env.VUE_APP_RISK_API}/risk/${actionName}`, payload).then((result: any) => {
                        console.log('Done');
                    });
                }
                else{
                    if(this.residualData.statusCode!=10425){
                        const actionNameMap: Record<number, string> = {
                            10404: 'invalid',
                            10407: 'reset'
                        };
                        const actionName = actionNameMap[payload[0].action];
                        if (!actionName) {
                            throw new Error('Invalid action');
                        } 
                        await this.$http.post(`${process.env.VUE_APP_RISK_API}/api/org/risk/${actionName}`, payload).then((result: any) => {
                            if(payload[0].action==10407 &&this.thisScreen == 'reset'){
                                toast.info('Task Reset', {
                                    timeout: 1000,
                                    closeOnClick: true,
                                    closeButton: 'button',
                                    icon: true
                                });
                            } else if(payload[0].action==10404 &&this.thisScreen == 'deactive'){
                                toast.info('Task Invalid', {
                                    timeout: 1000,
                                    closeOnClick: true,
                                    closeButton: 'button',
                                    icon: true
                                });
                            } 
                            console.log('Done');
                        });
                    }
                }
            } catch (e) {
                toast.error(`error`, {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                });
            }
        },
        async createWorkFlowTask(payload: any,actionType:any) {
            // payload.systems = payload.systems.value;
            try {
                payload[0].tier = 3;
                if (Object.keys(payload[0]).includes('insertedIds')) {
                    delete payload[0].insertedIds;
                }
                if (Object.keys(payload[0]).includes('residual')) {
                    delete payload[0].residual;
                }
                let residualArr:any;
                let riskJustification = payload[0].comments;
                delete payload[0].comments;
                let action = payload[0].action;
                if(actionType==10403 || actionType == 10424 || this.residualData.statusCode==10425){
                    residualArr={
                        legal:this.residualData.legal,
                        business:this.residualData.business,
                        financial:this.residualData.financial,
                        operations:this.residualData.operations,
                        likelihood:this.residualData.likelihood
                    }
                }
                if(actionType==10403 || actionType == 10419|| actionType == 10424 || actionType == 10425){
                 let acceptData=[{
                    tier:3,
                    treatmentType:action,
                    createdAt:payload[0].createdAt,
                    createdBy:payload[0].createdBy,
                    systems:payload[0].systems,
                    riskId:this.residualData._id,
                    residualRisk: residualArr ? [residualArr] : []

                }]
                delete payload[0].comments;
                delete payload[0].process,
                delete payload[0].action,
                delete payload[0].createdBy;
                delete payload[0].createdAt
                payload =acceptData
                }
                if(actionType!=10404 && actionType!=10407){
                    if(payload[0].treatmentType && payload[0].treatmentType==10403){
                        payload[0].acceptSummary = riskJustification;
                    }
                    else if(payload[0].treatmentType && payload[0].treatmentType==10419){
                        payload[0].avoidSummary = riskJustification;
 
                    }else if(payload[0].treatmentType && payload[0].treatmentType==10424){
                        payload[0].transferSummary = riskJustification;
 
                    }else if(payload[0].treatmentType && payload[0].treatmentType==10425){
                        payload[0].moniteredSummary = riskJustification;
 
                    }else{
                        payload[0].comments = riskJustification;
                    }
                    await this.$http.post(`${process.env.VUE_APP_WORKFLOW_API}/api/org/trigger/workflow/${process.env.VUE_APP_RISK_WORKFLOW_ACTION_ID}/risk/task`, payload).then((result: any) => {
                        this.insertedIds = result.data;
                        if(this.thisScreen == 'Acceptance'){
                            toast.info('Task Accepted', {
                                timeout: 1000,
                                closeOnClick: true,
                                closeButton: 'button',
                                icon: true
                            });
                        } else if(this.thisScreen == 'Avoid'){
                            toast.info('Task Avoided', {
                                timeout: 1000,
                                closeOnClick: true,
                                closeButton: 'button',
                                icon: true
                            });
                        } else if(this.thisScreen == 'Transfer'){
                            toast.info('Task Transferd', {
                                timeout: 1000,
                                closeOnClick: true,
                                closeButton: 'button',
                                icon: true
                            });
                        } else  {
                            toast.info('Task Created', {
                                timeout: 1000,
                                closeOnClick: true,
                                closeButton: 'button',
                                icon: true
                            });
                        }
                    });
                    payload[0].insertedIds = [this.insertedIds];
                    payload[0].residual =[residualArr];
                    // payload[0].comments = riskJustification;
                    payload[0].action = action;
                    
                    if(action==10419 || (action == 10425 && payload[0].residual[0]==undefined)){
                        payload[0].residual=[];
                    }
                }
                else{
                    if(payload[0].action && payload[0].action==10407){
                        payload[0].resetSummary = riskJustification;
                    }
                    else if(payload[0].action && payload[0].action==10404){
                        payload[0].invalidSummary = riskJustification;
 
                    }else{
                        payload[0].comments = riskJustification;
                    }
                }
                payload[0].tier = 3;
                await this.createActionForRisk(payload);
                this.applyPopup = false;
            } catch (e) {
                toast.error(`error`, {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                });
            
            } finally {
                this.clickOnButton = false
            }
        },
        async getAllTasks() {
            await this.$http.get(`${process.env.VUE_APP_RISK_API}/api/org/tasks/getall`).then((result: any) => {
                this.tasksData = result.data;
            });
        },
        async getBusinessEntities() {
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/businessEntities/getall`).then((result: any) => {
                result.data.map((obj: any) => {
                    var mainName = this.tenantsSelect.find((tenant: any) => {
                        return tenant.value == obj.entityName;
                    });
                    if (mainName == undefined && !this.managedByOptions.includes(obj.entityName)) {
                        this.managedByOptions.push({label:obj.entityDisplayName,value:obj._id});
                        this.businessEntityList.push({ label: obj.entityName, value: obj._id });
                    } else if (mainName != undefined && !this.managedByOptions.includes(mainName.label)) {
                        this.managedByOptions.push(mainName.label);
                        this.businessEntityList.push(mainName.label);
                    }
                });
            });
        },
        async getThirdParties() {
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/getall/${20003}`).then((result: any) => {
                result.data.map((obj: any) => {
                    if (!this.managedByOptions.includes(obj.name)) {
                        this.managedByOptions.push({label:obj.displayName,value:obj._id});
                    }
                });
            });
        },
        async toggleTabs(navIndex: any) {
            this.dataLoading = true;

            this.index = navIndex.id;
            this.selectedIndex = navIndex.id;
            sessionStorage.setItem('selectedTab', navIndex.id);
            this.selectedTabObj = navIndex;
            this.infoTableRow = [];
            if (navIndex.id == 0) {
                await this.getOrgSystemRisks();
                this.navIndexNums.index = 0;
                this.navIndexNums.name = 'Risks';
                emitter.emit('visible', false);
                this.showFilters = false;
            } else if (navIndex.id == 1) {
                await this.getSystemInformation();
                await this.getInformations();
                this.navIndexNums.index = 1;
                this.navIndexNums.name = 'Information';
                emitter.emit('visible', false);
                this.showFilters = false;
            } else if (navIndex.id == 2) {
                await this.getSystemInformation();
                this.navIndexNums.index = 2;
                this.navIndexNums.name = 'Properties';

                // this.changeCountry(this.system.country);
                // this.changeState(this.system.state);
            } else if (navIndex.id == 3 && (this.userInfo.currentRole == 10207|| ((this.userInfo.organisationType==10701 && this.userInfo.role_id!=10217) ||(this.userInfo.organisationType==10702 && this.userInfo.roleId!=10217)))) {
                this.discovery = true;
                await this.getRisksDiscoveryForSystem();
                await this.getClientSystemRisks();
                this.checkedItems = [];
                this.navIndexNums.index = 3;
                this.navIndexNums.name = 'Risk Discovery';
                emitter.emit('visible', false);
                this.showFilters = false;
                this.loadAndDisplayTable();
            }

            this.dataLoading = false
        },
        loadAndDisplayTable() {
            setTimeout(() => {
                this.discovery = false;
            }, 300);
        },

        showPriorityPopUpAction(data: any) {
            this.mainRisk = { ...data };
            this.riskObjCopy = { ...data };
            this.showPriorityPopUp = true;

            this.riskPriorityShow.risk = data.risk;
            this.riskPriorityShow.priority = data.priority;
            this.riskPriorityShow.justification = '';

            this.priorityDummy.risk = data.risk;
            this.priorityDummy.priority = data.priority;
            this.priorityDummy.justification = '';
        },

        closePriorityPopup() {
            this.resetRiskPriority();
            this.showPriorityPopUp = false;
        },

        cancelPriorityBtn() {
            this.riskPriorityShow.risk = this.priorityDummy.risk;
            this.riskPriorityShow.priority = this.priorityDummy.priority;
            this.riskPriorityShow.justification = '';
            this.priorityDummy.justification = '';
            this.v$.$reset();
        },

        async addOrUpdatePriority() {
            this.v$.$touch();
            if (!this.v$.riskPriorityShow.$invalid) {
                this.clickOnButton = true
                this.mainRisk.priority = this.riskPriorityShow.priority;
                this.mainRisk.priorityComments = this.riskPriorityShow.justification;

                let riskData = { ...this.mainRisk };

                let oldObj: any = {};
                let newObj: any = {};
                Object.keys(riskData).map((key: any) => {
                    if (riskData[key] != this.riskObjCopy[key] && key != 'updatedValues' && key != 'priorityComments') {
                        oldObj[key] = this.riskObjCopy[key];
                        newObj[key] = riskData[key];
                    }
                });
                riskData.updatedValues = { oldRisk: [], newRisk: [] };
                riskData.updatedValues.oldRisk.push(oldObj);
                riskData.updatedValues.newRisk.push(newObj);

                this.risk = [];

                this.risk.push(riskData);
                //updatingRisk
                await this.updateRisk();

                this.v$.$reset();
                this.mainRisk = {};
            } else {
                toast.error(`error`, {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                });
            }
        },

        resetRiskPriority() {
            this.riskPriorityShow.risk = '';
            this.riskPriorityShow.priority = null;
            this.riskPriorityShow.justification = '';
            // this.riskPriorityShow._id=null;
            this.priorityDummy.risk = '';
            this.priorityDummy.priority = null;
            this.priorityDummy.justification = '';
            // this.priorityDummy._id=null;
            this.v$.$reset();
        },
        // updateButtonStates() {
        //     const tabContainer = this.$refs.tabContainer;
        //     if (tabContainer) {
        //         if (!this.isSmallScreen) {
        //             this.canScrollLeft = tabContainer.scrollLeft > 0;
        //             this.canScrollRight = tabContainer.scrollLeft + tabContainer.clientWidth < tabContainer.scrollWidth;
        //         } else {
        //             this.canScrollLeft = this.currentGroupIndex > 0;
        //             this.canScrollRight = this.currentGroupIndex < this.totalGroups - 1;
        //         }
        //     }
        // },
        // handleResize() {
        //     this.isSmallScreen = window.innerWidth <= 768;
        //     if (this.isSmallScreen) {
        //         this.calculateTabsPerGroup();
        //         if (this.currentGroupIndex > this.totalGroups - 1) {
        //             this.scrollTabs('left');
        //         }
        //     } else {
        //         this.tabsPerGroup = this.calculateTabsForLargeScreen();
        //         this.updateVisibleTabs();
        //     }
        //     this.updateButtonStates();
        // },
        // calculateTabsPerGroup() {
        //     const tabContainerWidth = this.$refs.tabContainer.clientWidth;

        //     let sumWidth = 0;
        //     let count = 0;
        //     const tabs = this.carouselHead;

        //     for (let i = 0; i < tabs.length; i++) {
        //         const tabWidth = this.getTabWidth(tabs[i]);

        //         if (sumWidth + tabWidth > tabContainerWidth) {
        //             break;
        //         }

        //         sumWidth += tabWidth;
        //         count++;
        //     }
        //     this.tabsPerGroup = count;
        //     this.updateVisibleTabs();
        // },
        // calculateTabsForLargeScreen() {
        //     const tabContainerWidth = this.$refs.tabContainer.clientWidth;

        //     const tabs = this.carouselHead;
        //     let sumWidth = 0;
        //     let count = 0;

        //     for (let i = 0; i < tabs.length; i++) {
        //         const tabWidth = this.getTabWidth(tabs[i]);

        //         if (sumWidth + tabWidth > tabContainerWidth) {
        //             break;
        //         }

        //         sumWidth += tabWidth;
        //         count++;
        //     }
        //     return count;
        // },
        // getTabWidth(tab: any) {
        //     // Simulate tab width calculation; replace with your actual logic
        //     const dummyDiv = document.createElement('div');
        //     dummyDiv.innerHTML = tab.displayName;
        //     dummyDiv.style.display = 'inline-block';
        //     dummyDiv.style.visibility = 'hidden';
        //     document.body.appendChild(dummyDiv);
        //     const width = dummyDiv.clientWidth;
        //     document.body.removeChild(dummyDiv);
        //     return width + 24; // Adjust padding or margin as needed
        // },
        // async updateVisibleTabs() {
        //     if (!this.isSmallScreen) {
        //         this.visibleTabs = [...this.carouselHead];
        //     } else {
        //         const startIdx = this.currentGroupIndex * this.tabsPerGroup;
        //         const endIdx = startIdx + this.tabsPerGroup;
        //         this.visibleTabs = this.carouselHead.slice(startIdx, endIdx);
        //         if (this.visibleTabs) {
        //             let savedTabKey: any = sessionStorage.getItem('selectedTab');
        //             if (savedTabKey) {
        //                 savedTabKey = parseInt(savedTabKey)
        //                 const savedTab = this.visibleTabs.find((tab: any) => tab.id == savedTabKey);
        //                 if (savedTab) {
        //                     await this.toggleTabs(savedTab);
        //                 }else{
        //                     this.selectedTabObj = { displayName: 'Risks', name: 'Risk', id: 0 },
        //                     this.selectedIndex = 0;
        //                     this.navIndexNums = { index: 0, name: 'Risks' };
        //                 }
        //             }
        //             else{
        //                 this.selectedTabObj = { displayName: 'Risks', name: 'Risk', id: 0 },
        //                 this.navIndexNums = { index: 0, name: 'Risks' };
        //                 this.selectedIndex = 0;
        //                 await this.toggleTabs(this.selectedTabObj);
        //             }
        //         }
        //         this.totalGroups = Math.ceil(this.carouselHead.length / this.tabsPerGroup);
        //     }
        //     this.updateButtonStates();
        // },
        // scrollTabs(direction: any) {
        //     const tabContainer = this.$refs.tabContainer;
        //     if (tabContainer) {
        //         if (!this.isSmallScreen) {
        //             const scrollAmount = this.calculateScrollAmount(direction);
        //             if (direction === 'left') {
        //                 tabContainer.scrollLeft -= scrollAmount;
        //             } else if (direction === 'right') {
        //                 tabContainer.scrollLeft += scrollAmount;
        //             }
        //             this.updateButtonStates();
        //         } else {
        //             if (direction === 'left' && this.currentGroupIndex > 0) {
        //                 this.currentGroupIndex--;
        //             } else if (direction === 'right' && this.currentGroupIndex < this.totalGroups - 1) {
        //                 this.currentGroupIndex++;
        //             }
        //             this.updateVisibleTabs();
        //             this.updateButtonStates(); // Update button states after changing currentGroupIndex
        //         }
        //     }
        // },
        // calculateScrollAmount(direction: any) {
        //     const tabContainer = this.$refs.tabContainer;
        //     const visibleTabs = this.visibleTabs;
        //     let sumWidth = 0;
        //     let scrollAmount = 0;

        //     if (direction === 'left') {
        //         for (let i = visibleTabs.length - 1; i >= 0; i--) {
        //             const tabWidth = this.getTabWidth(visibleTabs[i]);
        //             if (sumWidth + tabWidth > tabContainer.clientWidth) {
        //                 break;
        //             }
        //             sumWidth += tabWidth;
        //             scrollAmount += tabWidth;
        //         }
        //     } else if (direction === 'right') {
        //         for (let i = 0; i < visibleTabs.length; i++) {
        //             const tabWidth = this.getTabWidth(visibleTabs[i]);
        //             if (sumWidth + tabWidth > tabContainer.clientWidth) {
        //                 break;
        //             }
        //             sumWidth += tabWidth;
        //             scrollAmount += tabWidth;
        //         }
        //     }
        //     return scrollAmount;
        // },
        
        // handleScroll() {
        //     this.updateButtonStates();
        // }
    },
    async created() {
        this.getallUsers();
        this.countriesStatesCities.map((obj: any) => {
            this.countriesList.push(obj.CountryName);
        });
        let presentSystem = this.$route.params.systemId;
         this.allSystems.forEach((data: any) => {
         if(data._id!= undefined ||data._id!=null){
            if(data._id==presentSystem){
                this.systemObj=data
            }
        }
         
         })
        let matchedData = this.allSystems.find((s:any)=>s._id == presentSystem);
        if(matchedData && matchedData!=undefined){
        this.hostingProviderData=this.businessEntityList.find((obj:any)=>obj.value == matchedData.ownedBy)
        }
        // this.permissions = this.userInfo.permissions[0].resources.filter((userPer: any) => {
        //     return userPer.id == 20008;
        // });
        // this.permissions = this.permissions[0].permissions;
    },
    beforeUnmount() {
        // window.removeEventListener('resize', this.handleResize);
        sessionStorage.removeItem('selectedTab')
    }
});
</script>

